import Vue from 'vue';
import Login from './login.js';
import Index from '../views/Index.vue';
import VueRouter from 'vue-router';
// import Home from '../views/Home.vue';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const routes = [{
  path: '/',
  name: 'Index',
  component: Index,
  children: [
     //票据冲红列表
    {
      path: '/ticketHedgingIndex',
      name: 'ticketHedgingIndex',
      // meta: { requiresAuth: true },
      component: () => import('../views/ticketHedgingManagement/ticketHedgingIndex.vue'),
    },
    //票据冲红新增
    {
      path: '/ticketHedgingAdd',
      name: 'ticketHedgingAdd',
      // meta: { requiresAuth: true },
      component: () => import('../views/ticketHedgingManagement/ticketHedgingAdd.vue'),
    },
    //票据冲红详情
    {
      path: '/ticketHedingDetail',
      name: 'ticketHedingDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/ticketHedgingManagement/ticketHedingDetail.vue'),
    },
    // 组织管理首页
    {
      path: '/companiesHome',
      name: 'companiesHome',
      // meta: { requiresAuth: true },
      component: () => import('../views/organizationalStructure/companiesHomes.vue'),
    },
    {
      path: '/organizationalStructure',
      name: 'organizationalStructure',
      // meta: { requiresAuth: true },
      component: () => import('../views/organizationalStructure/organizationalStructure.vue'),
    },
    // 核算单元
    {
      path: '/businessUnit',
      name: 'businessUnit',
      // meta: { requiresAuth: true },
      component: () => import('../views/organizationalStructure/businessUnit.vue'),
    },
    // 运营单元
    {
      path: '/operationUnit',
      name: 'operationUnit',
      // meta: { requiresAuth: true },
      component: () => import('../views/organizationalStructure/operationUnit.vue'),
    },
    // 组织管理首页
    {
      path: '/postManagement',
      name: 'postManagement',
      // meta: { requiresAuth: true },
      component: () => import('../views/organizationalStructure/postManagement.vue'),
    },
    {
      path: '/userManagement',
      name: 'userManagement',
      meta: {
        requiresAuth: true
      },
      component: () => import('../views/user-management.vue'),
    },
    {
      path: '/multiTerminalConfiguration',
      name: 'multiTerminalConfiguration',
      meta: {
        requiresAuth: true
      },
      component: () => import('../views/multi-terminal-configuration.vue'),
    },
    {
      path: '/importPersonnel',
      name: 'importPersonnel',
      // meta: { requiresAuth: true },
      component: () => import('../views/organizationalStructure/importPersonnel.vue'),
    },
    // 药企人员备案管理 药企人员备案管理 导入
    {
      path: '/importPersonnelFiling',
      name: 'importPersonnelFiling',
      // meta: { requiresAuth: true },
      component: () => import('../views/personnelFiling/importPersonnelFiling.vue'),
    },
    // {
    //   path: '/managementPersonnel',
    //   name: 'managementPersonnel',
    //   // meta: { requiresAuth: true },
    //   component: () => import('../views/organizationalStructure/managementPersonnel.vue'),
    // },
    {
      path: '/managementPersonnelCheck',
      name: 'managementPersonnelCheck',
      // meta: { requiresAuth: true },
      component: () => import('../views/organizationalStructure/managementPersonnelCheck.vue'),
    },
    // 经纪人管理
    // 经纪人管理 入职审批
    {
      path: '/entryApproval',
      name: 'entryApproval',
      meta: {
        requiresAuth: true
      },
      meta: {
        keepAlive: true,
        isBack: false, //用于判断上一个页面是哪个
      },
      component: () => import('../views/brokerManagement/entry-approval.vue'),
    },
    // 经纪人管理 入职审批详情
    {
      path: '/entryApproval/detail',
      name: '/entryApproval/detail',
      meta: {
        requiresAuth: true
      },
      component: () => import('../views/brokerManagement/entry-approval-details.vue'),
    },
    // 经纪人管理 花名册管理-编辑或查看
    {
      path: '/brokerInsuredDetail',
      name: 'brokerInsuredDetail',
      meta: {
        requiresAuth: true
      },
      component: () => import('../views/brokerManagement/brokerInsuredDetail.vue'),
    },
    // 经纪人管理 花名册管理-新增
    {
      path: '/brokerInsuredEdit',
      name: 'brokerInsuredEdit',
      meta: {
        requiresAuth: true
      },
      component: () => import('../views/brokerManagement/brokerInsuredEdit.vue'),
    },
    // 经纪人管理 花名册审批
    {
      path: '/brokerInsuredApprovalList',
      name: 'brokerInsuredApprovalList',
      meta: {
        requiresAuth: true
      },
      component: () => import('../views/brokerManagement/brokerInsuredApprovalList.vue'),
    },
    // 经纪人管理 花名册审批
    {
      path: '/brokerInsuredApprovalDetail',
      name: 'brokerInsuredApprovalDetail',
      meta: {
        requiresAuth: true
      },
      component: () => import('../views/brokerManagement/brokerInsuredApprovalDetail.vue'),
    },
    // 经纪人管理 花名册管理 详情
    {
      path: '/brokerInsuredManagementDetails',
      name: '/brokerInsuredManagementDetails',
      meta: {
        requiresAuth: true
      },
      component: () => import('../views/brokerManagement/brokerInsuredManagementDetails.vue'),
    },
    //经纪人管理  人员档案字段设置
    {
      path: '/personnelFieldSet',
      name: 'personnelFieldSet',
      // meta: { requiresAuth: true },
      component: () => import('../views/brokerManagement/personnelFieldSet.vue'),
    },
    //自由用工管理
    //绩效提报
    {
      path: '/performanceReporting',
      name: 'performanceReporting',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/performanceReporting.vue'),
      meta: {
        keepAlive: true,
      },
    },
    //绩效提报 详情
    {
      path: '/performanceReporting/detail',
      name: '/performanceReporting/detail',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/performanceReportingDetail.vue'),
    },
    //提报审核
    {
      path: '/submitForReview',
      name: 'submitForReview',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/submitForReview.vue'),
    },
    //提报详情
    {
      path: '/submitForReviewDetail',
      name: 'submitForReviewDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/submitForReviewDetail.vue'),
    },
    //绩效明细
    {
      path: '/performanceDetailsAll',
      name: 'performanceDetailsAll',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/performanceDetailsAll.vue'),
    },
    //绩效审批 列表
    {
      path: '/performanceAuditingList',
      name: 'performanceAuditingList',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/performanceAuditingList.vue'),
      meta: {
        keepAlive: true,
      },
    },
    //绩效审批 审批
    {
      path: '/performanceAuditing',
      name: 'performanceAuditing',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/performanceAuditing.vue'),
    },
    //绩效审批 提报详情
    {
      path: '/performanceAuditingDetail',
      name: 'performanceAuditingDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/performanceAuditingDetail.vue'),
    },
    // //绩效审批 绩效明细
    // {
    //   path: '/performanceAuditingDetailsAll',
    //   name: 'performanceAuditingDetailsAll',
    //   // meta: { requiresAuth: true },
    //   component: () => import('../views/freeEmployment/performanceAuditingDetailsAll.vue'),
    // },
    //绩效发放 列表
    {
      path: '/performancePayment',
      name: 'performancePayment',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/performancePayment.vue'),
      meta: {
        keepAlive: true,
      },
    },
    //绩效发放 绩效明细
    {
      path: '/performancePaymentDetailsAll',
      name: 'performancePaymentDetailsAll',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/performancePaymentDetailsAll.vue'),
    },
    //绩效发放 发放详情
    {
      path: '/performancePaymentDetails',
      name: 'performancePaymentDetails',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/performancePaymentDetails.vue'),
    },
    //绩效发放 绩效费用发放查询
    {
      path: '/performanceFeePayment',
      name: 'performanceFeePayment',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/performanceFeePayment.vue'),
    },
    //社金管理  参保人管理
    {
      path: '/insuredManagement',
      name: 'insuredManagement',
      meta: {
        keepAlive: true,
        isBack: false, //用于判断上一个页面是哪个
      },
      // meta: { requiresAuth: true },
      component: () => import('../views/socialFundManagement/insuredManagement.vue'),
    },
    //社金管理  在缴明细
    {
      path: '/paymentDetails',
      name: 'paymentDetails',
      // meta: { requiresAuth: true },
      component: () => import('../views/socialFundManagement/paymentDetails.vue'),
    },
    //社金管理  在缴详情
    {
      path: '/insuredManagement/insuredManagementDetails',
      name: 'insuredManagementDetails',
      // meta: { requiresAuth: true },
      component: () => import('../views/socialFundManagement/insuredManagementDetails.vue'),
    },
    //社金管理  在缴详情
    {
      path: '/paymentInsuredDetails',
      name: 'paymentInsuredDetails',
      // meta: { requiresAuth: true },
      component: () => import('../views/socialFundManagement/paymentInsuredDetails.vue'),
    },
    //社金管理  在缴详情 明细
    {
      path: '/insuredDetail',
      name: 'insuredDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/socialFundManagement/insuredDetail.vue'),
    },
    //数据管理  数据生成
    {
      path: '/dataGeneration',
      name: 'dataGeneration',
      // meta: { requiresAuth: true },
      component: () => import('../views/importManagement/dataGeneration.vue'),
    },
    //导入管理  销售流向导入
    {
      path: '/importOfSalesFlow',
      name: 'importOfSalesFlow',
      // meta: { requiresAuth: true },
      component: () => import('../views/importManagement/importOfSalesFlow.vue'),
    },
    //数据导入  终端导入
    {
      path: '/importTerminal',
      name: 'importTerminal',
      // meta: { requiresAuth: true },
      component: () => import('../views/importCustomerManagement/importTerminal.vue'),
    },
    //数据导入  商业公司导入
    {
      path: '/importCommercialCompany',
      name: 'importCommercialCompany',
      // meta: { requiresAuth: true },
      component: () => import('../views/importCustomerManagement/importCommercialCompany.vue'),
    },
    //数据导入  医院导入
    {
      path: '/importHospital',
      name: 'importHospital',
      component: () => import('../views/importCustomerManagement/importHospital.vue'),
    },
    //数据导入  医生导入
    {
      path: '/importDoctor',
      name: 'importDoctor',
      component: () => import('../views/importCustomerManagement/importDoctor.vue'),
    },
    //资料管理 医生资料
    {
      path: '/doctorInformation',
      name: 'doctorInformation',
      meta: { keepAlive: true },
      component: () => import('../views/informationManagement/doctorInformation.vue'),

    },
    // 医生审核
    {
      path: '/doctorAudit',
      name: 'doctorAudit',
      // meta: { keepAlive: true },
      component: () => import('../views/informationManagement/doctorAudit.vue'),
    },
    // 资料管理 编辑医生
    {
      path: '/doctorDetail',
      name: 'doctorDetail',
      component: () => import('../views/informationManagement/doctorDetail.vue'),
    },
    // 数据管理 终端查询
    {
      path: '/terminalQuery',
      name: 'terminalQuery',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/terminalQuery.vue'),
    },
    // 审批管理 流程设置
    {
      path: '/processSettings',
      name: 'processSettings',
      // meta: { requiresAuth: true },
      meta: {
        keepAlive: true,
      },
      component: () => import('../views/processManagement/processSettings.vue'),
    },
    // 审批管理 设置审批人 costApproval
    {
      path: '/examinerSet',
      name: 'examinerSet',
      // meta: { requiresAuth: true },
      component: () => import('../views/processManagement/examinerSet.vue'),
    },
    // 审批管理 流程审批
    {
      path: '/processList',
      name: 'processList',
      // meta: { requiresAuth: true },
      component: () => import('../views/processManagement/processList.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 审批管理 会议费用申请详情
    {
      path: '/approvalDetail',
      name: 'approvalDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/processManagement/approvalDetail.vue'),
    },
    // 审批管理 线上会议申请详情
    {
      path: '/onlineDetail',
      name: 'onlineDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/processManagement/onlineDetail.vue'),
    },
    // 审批管理 会议报销详情
    {
      path: '/reimbursementDetail',
      name: 'reimbursementDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/processManagement/reimbursementDetail.vue'),
    },
    // 审批管理 学术活动申请详情
    {
      path: '/academicDetail',
      name: 'academicDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/processManagement/academicDetail.vue'),
    },
    // 审批管理 潜在客户详情
    {
      path: '/customerDetail',
      name: 'customerDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/processManagement/customerDetail.vue'),
    },
    // 会议管理 会议列表
    {
      path: '/meetingManagement',
      name: 'meetingManagement',
      // meta: { requiresAuth: true },
      component: () => import('../views/meetingManagement/meetingManagement.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 会议管理 会议列表
    {
      path: '/meetingMangementNew',
      name: 'meetingMangementNew',
      // meta: { requiresAuth: true },
      component: () => import('../views/meetingManagement/meetingMangementNew.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 会议管理 会议详情
    {
      path: '/meetingDetail',
      name: 'meetingDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/meetingManagement/meetingDetail.vue'),
    },
    // 会议管理 会议详情
    {
      path: '/meetingDetailNew',
      name: 'meetingDetailNew',
      // meta: { requiresAuth: true },
      component: () => import('../views/meetingManagement/meetingDetailNew.vue'),
    },
    // 会议管理 会议详情
    {
      path: '/meetingPark',
      name: 'meetingPark',
      // meta: { requiresAuth: true },
      component: () => import('../views/meetingManagement/meetingPark.vue'),
    },
    // 会议管理 会议平台配置
    {
      path: '/meetingStConf',
      name: 'meetingStConf',
      // meta: { requiresAuth: true },
      component: () => import('../views/meetingManagement/meetingStConf.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 会议管理 会议方案配置
    {
      path: '/meetingCaConf',
      name: 'meetingCaConf',
      // meta: { requiresAuth: true },
      component: () => import('../views/meetingManagement/meetingCaConf.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 会议申请模板
    {
      path: '/reportProcess',
      name: 'reportProcess',
      // meta: { requiresAuth: true },
      component: () => import('../views/processManagement/report-process.vue'),
    },
    // 会议规则设置
    {
      path: '/ruleSetting',
      name: 'ruleSetting',
      // meta: { requiresAuth: true },
      component: () => import('../views/processManagement/ruleSetting.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 活动管理 列表
    {
      path: '/activityManagementList',
      name: 'activityManagementList',
      // meta: { requiresAuth: true },
      component: () => import('../views/activityManagement/activityManagementList.vue'),
    },
    //推广记录
    {
      path: '/promotionList',
      name: 'promotionList',
      component: () => import('../views/activityManagement/promotionList.vue'),
    },
    //数据分析 数据管理
    {
      path: '/algorithmManagement',
      name: 'algorithmManagement',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataAnalysis/algorithmManagement.vue'),
    },
    //数据分析 数据准备
    {
      path: '/dataPreparation',
      name: 'dataPreparation',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataAnalysis/dataPreparation.vue'),
    },
    //数据分析 算法计算
    {
      path: '/algorithmicCalculation',
      name: 'algorithmicCalculation',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataAnalysis/algorithmicCalculation.vue'),
    },
    //数据分析 销售预测分析
    {
      path: '/salesForecastAnalysis',
      name: 'salesForecastAnalysis',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataAnalysis/salesForecastAnalysis.vue'),
    },
    //数据分析 商品分类分析
    {
      path: '/commodityClassificationAnalysis',
      name: 'commodityClassificationAnalysis',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataAnalysis/commodityClassificationAnalysis.vue'),
    },
    //数据分析 算法结果查询
    {
      path: '/algorithmResultQuery',
      name: 'algorithmResultQuery',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataAnalysis/algorithmResultQuery.vue'),
    },
    // 数据字典
    {
      path: '/dataDictionary',
      name: 'dataDictionary',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/dataDictionary.vue'),
    },
    // 标准参数配置
    {
      path: '/standardParameters',
      name: 'standardParameters',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/standardParameters.vue'),
    },
    // 算法计算
    {
      path: '/tenantAlgorithmicCalculation',
      name: 'tenantAlgorithmicCalculation',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/tenantAlgorithmicCalculation.vue'),
    },
    // 算法计算明细
    {
      path: '/tenantAlgorithmicCalculationDetails',
      name: 'tenantAlgorithmicCalculationDetails',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/tenantAlgorithmicCalculationDetails.vue'),
    },
    {
      path: '/h5ConfigList',
      name: 'h5ConfigList',
      // meta: { requiresAuth: true },
      meta: {
        keepAlive: true,
      },
      component: () => import('../views/systemParameter/h5ConfigList.vue'),
    },
    {
      path: '/h5ConfigLog',
      name: 'h5ConfigLog',
      meta: {
        keepAlive: true,
      },
      component: () => import('../views/systemParameter/h5ConfigLog.vue'),
    },
    {
      path: '/lineStopRuleList',
      name: 'lineStopRuleList',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/lineStopRuleList.vue'),
    },
    {
      path: '/lineStopRuleEdit',
      name: 'lineStopRuleEdit',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/lineStopRuleEdit.vue'),
    },
    {
      path: '/h5ConfigTenantList',
      name: 'h5ConfigTenantList',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/h5ConfigTenantList.vue'),
    },
    {
      path: '/h5ConfigFieldAdd',
      name: 'h5ConfigFieldAdd',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/h5ConfigFieldAdd.vue'),
    },
    //题库管理
    {
      path: '/questionBankMangement',
      name: 'questionBankMangement',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/questionBankMangement.vue'),
    },
    //标签导入记录
    {
      path: '/labelImportRecord',
      name: 'labelImportRecord',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/labelImportRecord.vue'),
    },
    //问卷调查
    {
      path: '/questionnaireList',
      name: 'questionnaireList',
      // meta: { requiresAuth: true },
      meta:{
        keepAlive:true,
      },
      component: () => import('../views/systemParameter/questionnaireList.vue'),
    },
    //问卷调查添加
    {
      path: '/questionnaireAdd',
      name: 'questionnaireAdd',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/questionnaireAdd.vue'),
    },
    {
      path: '/questionnaireReview',
      name: 'questionnaireReview',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/questionnaireReview.vue'),
    },
    //调研对象
    {
      path: '/researchObjectList',
      name: 'researchObjectList',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/researchObjectList.vue'),
    },
    // 算法分配
    {
      path: '/algorithmAllocation',
      name: 'algorithmAllocation',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/algorithmAllocation.vue'),
    },
    //导入管理  销售数据导入
    {
      path: '/importSalesData',
      name: 'importSalesData',
      // meta: { requiresAuth: true },
      component: () => import('../views/importManagement/importSalesData.vue'),
    },
    //导入管理  运费报价
    {
      path: '/importFreightQuotation',
      name: 'importFreightQuotation',
      // meta: { requiresAuth: true },
      component: () => import('../views/importManagement/importFreightQuotation.vue'),
    },
    //导入管理  仓储报价
    {
      path: '/importWarehouseQuotation',
      name: 'importWarehouseQuotation',
      // meta: { requiresAuth: true },
      component: () => import('../views/importManagement/importWarehouseQuotation.vue'),
    },
    //系统参数管理  数据字典
    {
      path: '/parameterDataDictionary',
      name: 'parameterDataDictionary',
      // meta: { requiresAuth: true },
      component: () => import('../views/parameterManagemant/parameterDataDictionary.vue'),
    },
    //系统参数管理  业务参数
    {
      path: '/businessParameters',
      name: 'businessParameters',
      // meta: { requiresAuth: true },
      component: () => import('../views/parameterManagemant/businessParameters.vue'),
    },
    //系统参数管理  AB测试配置
    {
      path: '/ABTestConfiguration',
      name: 'ABTestConfiguration',
      // meta: { requiresAuth: true },
      component: () => import('../views/parameterManagemant/ABTestConfiguration.vue'),
    },
    //账单管理  账单导入
    {
      path: '/expenseImport',
      name: 'expenseImport',
      // meta: { requiresAuth: true },
      component: () => import('../views/expenseManagement/expenseImport.vue'),
    },
    //账单管理  账单列表
    {
      path: '/expenseList',
      name: 'expenseList',
      // meta: { requiresAuth: true },
      component: () => import('../views/expenseManagement/expenseList.vue'),
    },
    // 报表配置平台菜单
    // 销售区域报货累计达成情况
    {
      path: '/orderTerritoryArrivalYTD',
      name: 'orderTerritoryArrivalYTD',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 报货产品排名
    {
      path: '/orderGoodsTop',
      name: 'orderGoodsTop',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 新老终端分析(流向)
    {
      path: '/salesNewOldAnalyse',
      name: 'salesNewOldAnalyse',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 终端报货排名(Rx)
    {
      path: '/orderTerminalTOP',
      name: 'orderTerminalTOP',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 拜访报货转化分析(Rx)
    {
      path: '/orderRxConvertion',
      name: 'orderRxConvertion',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 销售区域流向累计达成情况
    {
      path: '/salesTerritoryArrivalYTD',
      name: 'salesTerritoryArrivalYTD',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 会议分析
    {
      path: '/meetingAnalyse',
      name: 'meetingAnalyse',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 8个图表报表测试
    {
      path: '/eightChartTest',
      name: 'eightChartTest',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 报货数据总结(OTC运营报告)
    {
      path: '/orderOperationOTC',
      name: 'orderOperationOTC',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 报货月度趋势分析
    {
      path: '/orderMonthAnalyse',
      name: 'orderMonthAnalyse',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 终端销售排名
    {
      path: '/terminalSalesTOP',
      name: 'terminalSalesTOP',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 报货产品分析
    {
      path: '/orderGoodsMonthAnalyse',
      name: 'orderGoodsMonthAnalyse',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 终端报货排名(OTC)
    {
      path: '/orderOTCTerminalTOP',
      name: 'orderOTCTerminalTOP',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 库存质量分析
    {
      path: '/warehouseStockQuality',
      name: 'warehouseStockQuality',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 库存分析
    {
      path: '/warehouseStock',
      name: 'warehouseStock',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 拜访类型占比(OTC运营报告)
    {
      path: '/visitCategoryRatio',
      name: 'visitCategoryRatio',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 报货达成月趋势分析
    {
      path: '/orderArrival',
      name: 'orderArrival',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 终端RFM分析(OTC报货)
    {
      path: '/orderTerminalRFM',
      name: 'orderTerminalRFM',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 人均效能分析(报货OTC)
    {
      path: '/orderAverageStaff',
      name: 'orderAverageStaff',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 库龄分析
    {
      path: '/warehouseStockAge',
      name: 'warehouseStockAge',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 人员构成
    {
      path: '/staffComposite',
      name: 'staffComposite',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 拜访流向转化分析(OTC)
    {
      path: '/visitSalesConvertionOTC',
      name: 'visitSalesConvertionOTC',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 拜访流向转化分析(Rx)
    {
      path: '/visitSalesConvertionRx',
      name: 'visitSalesConvertionRx',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 新老终端分析(OTC报货)
    {
      path: '/newOldTerminalOTCAnalyse',
      name: 'newOldTerminalOTCAnalyse',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 销售达成月趋势分析
    {
      path: '/salesArrival',
      name: 'salesArrival',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 销售月度趋势分析
    {
      path: '/salesMonthAnalyse',
      name: 'salesMonthAnalyse',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    {
      path: '/multiTerminalConfiguration',
      name: 'multiTerminalConfiguration',
      meta: {
        requiresAuth: true
      },
      component: () => import('../views/multi-terminal-configuration.vue'),
    },
    {
      path: '/roleManagement',
      name: 'roleManagement',
      // meta: { requiresAuth: true },
      component: () => import('../views/organizationalStructure/roleManagement.vue'),
    },
    {
      path: '/managementPersonnel',
      name: 'managementPersonnel',
      // meta: { requiresAuth: true },
      component: () => import('../views/organizationalStructure/managementPersonnel.vue'),
    },
    // 经纪人管理
    // 经纪人管理 入职审批
    {
      path: '/entryApproval',
      name: 'entryApproval',
      meta: {
        requiresAuth: true
      },
      meta: {
        keepAlive: true,
        isBack: false, //用于判断上一个页面是哪个
      },
      component: () => import('../views/brokerManagement/entry-approval.vue'),
    },
    // 经纪人管理 入职审批详情
    {
      path: '/entryApproval/detail',
      name: '/entryApproval/detail',
      meta: {
        requiresAuth: true
      },
      component: () => import('../views/brokerManagement/entry-approval-details.vue'),
    },
    // 经纪人管理 花名册管理
    {
      path: '/brokerInsuredManagement',
      name: 'brokerInsuredManagement',
      meta: {
        requiresAuth: true,
        keepAlive: true
      },
      component: () => import('../views/brokerManagement/brokerInsuredManagement.vue'),
    },
    // 经纪人管理 花名册管理-编辑或查看
    {
      path: '/brokerInsuredDetail',
      name: 'brokerInsuredDetail',
      meta: {
        requiresAuth: true
      },
      component: () => import('../views/brokerManagement/brokerInsuredDetail.vue'),
    },
    // 经纪人管理 花名册管理 详情
    {
      path: '/brokerInsuredManagementDetails',
      name: '/brokerInsuredManagementDetails',
      meta: {
        requiresAuth: true
      },
      component: () => import('../views/brokerManagement/brokerInsuredManagementDetails.vue'),
    },
    //经纪人管理  人员档案字段设置
    {
      path: '/personnelFieldSet',
      name: 'personnelFieldSet',
      // meta: { requiresAuth: true },
      component: () => import('../views/brokerManagement/personnelFieldSet.vue'),
    },
    //自由用工管理
    //绩效提报
    {
      path: '/performanceReporting',
      name: 'performanceReporting',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/performanceReporting.vue'),
      meta: {
        keepAlive: true,
      },
    },
    //绩效提报 详情
    {
      path: '/performanceReporting/detail',
      name: '/performanceReporting/detail',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/performanceReportingDetail.vue'),
    },
    //提报审核
    {
      path: '/submitForReview',
      name: 'submitForReview',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/submitForReview.vue'),
    },
    //提报详情
    {
      path: '/submitForReviewDetail',
      name: 'submitForReviewDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/submitForReviewDetail.vue'),
    },
    //绩效明细
    {
      path: '/performanceDetailsAll',
      name: 'performanceDetailsAll',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/performanceDetailsAll.vue'),
    },
    //绩效审批 列表
    {
      path: '/performanceAuditingList',
      name: 'performanceAuditingList',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/performanceAuditingList.vue'),
      meta: {
        keepAlive: true,
      },
    },
    //绩效审批 审批
    {
      path: '/performanceAuditing',
      name: 'performanceAuditing',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/performanceAuditing.vue'),
    },
    //绩效审批 提报详情
    {
      path: '/performanceAuditingDetail',
      name: 'performanceAuditingDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/performanceAuditingDetail.vue'),
    },
    // //绩效审批 绩效明细
    // {
    //   path: '/performanceAuditingDetailsAll',
    //   name: 'performanceAuditingDetailsAll',
    //   // meta: { requiresAuth: true },
    //   component: () => import('../views/freeEmployment/performanceAuditingDetailsAll.vue'),
    // },
    //绩效发放 列表
    {
      path: '/performancePayment',
      name: 'performancePayment',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/performancePayment.vue'),
      meta: {
        keepAlive: true,
      },
    },
    //绩效发放 绩效明细
    {
      path: '/performancePaymentDetailsAll',
      name: 'performancePaymentDetailsAll',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/performancePaymentDetailsAll.vue'),
    },
    //绩效发放 发放详情
    {
      path: '/performancePaymentDetails',
      name: 'performancePaymentDetails',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/performancePaymentDetails.vue'),
    },
    //绩效发放 绩效费用发放查询
    {
      path: '/performanceFeePayment',
      name: 'performanceFeePayment',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/performanceFeePayment.vue'),
    },
    //社金管理  参保人管理
    {
      path: '/insuredManagement',
      name: 'insuredManagement',
      meta: {
        keepAlive: true,
        isBack: false, //用于判断上一个页面是哪个
      },
      // meta: { requiresAuth: true },
      component: () => import('../views/socialFundManagement/insuredManagement.vue'),
    },
    //社金管理  在缴明细
    {
      path: '/paymentDetails',
      name: 'paymentDetails',
      // meta: { requiresAuth: true },
      component: () => import('../views/socialFundManagement/paymentDetails.vue'),
    },
    //社金管理  在缴详情
    {
      path: '/insuredManagement/insuredManagementDetails',
      name: 'insuredManagementDetails',
      // meta: { requiresAuth: true },
      component: () => import('../views/socialFundManagement/insuredManagementDetails.vue'),
    },
    //社金管理  在缴详情
    {
      path: '/paymentInsuredDetails',
      name: 'paymentInsuredDetails',
      // meta: { requiresAuth: true },
      component: () => import('../views/socialFundManagement/paymentInsuredDetails.vue'),
    },
    //社金管理  在缴详情 明细
    {
      path: '/insuredDetail',
      name: 'insuredDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/socialFundManagement/insuredDetail.vue'),
    },
    //数据管理  数据生成
    {
      path: '/dataGeneration',
      name: 'dataGeneration',
      // meta: { requiresAuth: true },
      component: () => import('../views/importManagement/dataGeneration.vue'),
    },
    //导入管理  销售流向导入
    {
      path: '/importOfSalesFlow',
      name: 'importOfSalesFlow',
      // meta: { requiresAuth: true },
      component: () => import('../views/importManagement/importOfSalesFlow.vue'),
    },
    // 数据管理 终端查询
    {
      path: '/terminalQuery',
      name: 'terminalQuery',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/terminalQuery.vue'),
    },
    // 审批管理 流程设置
    {
      path: '/processSettings',
      name: 'processSettings',
      // meta: { requiresAuth: true },
      meta: {
        keepAlive: true,
      },
      component: () => import('../views/processManagement/processSettings.vue'),
    },
    // 审批管理 设置审批人 costApproval
    {
      path: '/examinerSet',
      name: 'examinerSet',
      // meta: { requiresAuth: true },
      component: () => import('../views/processManagement/examinerSet.vue'),
    },
    // 审批管理 流程审批
    {
      path: '/processList',
      name: 'processList',
      // meta: { requiresAuth: true },
      component: () => import('../views/processManagement/processList.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 审批管理 会议费用申请详情
    {
      path: '/approvalDetail',
      name: 'approvalDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/processManagement/approvalDetail.vue'),
    },
    // 审批管理 线上会议申请详情
    {
      path: '/onlineDetail',
      name: 'onlineDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/processManagement/onlineDetail.vue'),
    },
    // 审批管理 会议报销详情
    {
      path: '/reimbursementDetail',
      name: 'reimbursementDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/processManagement/reimbursementDetail.vue'),
    },
    // 审批管理 潜在客户详情
    {
      path: '/customerDetail',
      name: 'customerDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/processManagement/customerDetail.vue'),
    },
    // 会议管理 会议列表
    {
      path: '/meetingManagement',
      name: 'meetingManagement',
      // meta: { requiresAuth: true },
      component: () => import('../views/meetingManagement/meetingManagement.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 会议管理 会议列表
    {
      path: '/meetingMangementNew',
      name: 'meetingMangementNew',
      // meta: { requiresAuth: true },
      component: () => import('../views/meetingManagement/meetingMangementNew.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 会议管理 会议详情
    {
      path: '/meetingDetail',
      name: 'meetingDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/meetingManagement/meetingDetail.vue'),
    },
    // 会议管理 会议详情
    {
      path: '/meetingDetailNew',
      name: 'meetingDetailNew',
      // meta: { requiresAuth: true },
      component: () => import('../views/meetingManagement/meetingDetailNew.vue'),
    },
    // 会议管理 会议详情
    {
      path: '/meetingPark',
      name: 'meetingPark',
      // meta: { requiresAuth: true },
      component: () => import('../views/meetingManagement/meetingPark.vue'),
    },
    // 会议管理 会议平台配置
    {
      path: '/meetingStConf',
      name: 'meetingStConf',
      // meta: { requiresAuth: true },
      component: () => import('../views/meetingManagement/meetingStConf.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 会议管理 会议方案配置
    {
      path: '/meetingCaConf',
      name: 'meetingCaConf',
      // meta: { requiresAuth: true },
      component: () => import('../views/meetingManagement/meetingCaConf.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 会议申请模板
    {
      path: '/reportProcess',
      name: 'reportProcess',
      // meta: { requiresAuth: true },
      component: () => import('../views/processManagement/report-process.vue'),
    },
    // 会议规则设置
    {
      path: '/ruleSetting',
      name: 'ruleSetting',
      // meta: { requiresAuth: true },
      component: () => import('../views/processManagement/ruleSetting.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 会议规则设置 bpmn设置
    {
      path: '/processQuery',
      name: 'processQuery',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/processQuery.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 活动管理 列表
    {
      path: '/activityManagementList',
      name: 'activityManagementList',
      // meta: { requiresAuth: true },
      component: () => import('../views/activityManagement/activityManagementList.vue'),
    },
    //推广记录
    {
      path: '/promotionList',
      name: 'promotionList',
      component: () => import('../views/activityManagement/promotionList.vue'),
    },
    //报告通知设置
    {
      path: '/reportNoticeConfig',
      name: 'reportNoticeConfig',
      component: () => import('../views/activityManagement/reportNoticeConfig.vue'),
    },
    //数据分析 数据管理
    {
      path: '/algorithmManagement',
      name: 'algorithmManagement',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataAnalysis/algorithmManagement.vue'),
    },
    //数据分析 数据准备
    {
      path: '/dataPreparation',
      name: 'dataPreparation',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataAnalysis/dataPreparation.vue'),
    },
    //数据分析 算法计算
    {
      path: '/algorithmicCalculation',
      name: 'algorithmicCalculation',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataAnalysis/algorithmicCalculation.vue'),
    },
    //数据分析 销售预测分析
    {
      path: '/salesForecastAnalysis',
      name: 'salesForecastAnalysis',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataAnalysis/salesForecastAnalysis.vue'),
    },
    //数据分析 商品分类分析
    {
      path: '/commodityClassificationAnalysis',
      name: 'commodityClassificationAnalysis',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataAnalysis/commodityClassificationAnalysis.vue'),
    },
    //数据分析 算法结果查询
    {
      path: '/algorithmResultQuery',
      name: 'algorithmResultQuery',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataAnalysis/algorithmResultQuery.vue'),
    },
    // 数据字典
    {
      path: '/dataDictionary',
      name: 'dataDictionary',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/dataDictionary.vue'),
    },
    // 标准参数配置
    {
      path: '/standardParameters',
      name: 'standardParameters',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/standardParameters.vue'),
    },
    // 算法计算
    {
      path: '/tenantAlgorithmicCalculation',
      name: 'tenantAlgorithmicCalculation',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/tenantAlgorithmicCalculation.vue'),
    },
    // 算法计算明细
    {
      path: '/tenantAlgorithmicCalculationDetails',
      name: 'tenantAlgorithmicCalculationDetails',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/tenantAlgorithmicCalculationDetails.vue'),
    },
    {
      path: '/h5ConfigList',
      name: 'h5ConfigList',
      // meta: { requiresAuth: true },
      meta: {
        keepAlive: true,
      },
      component: () => import('../views/systemParameter/h5ConfigList.vue'),
    },
    //题库管理
    {
      path: '/questionBankMangement',
      name: 'questionBankMangement',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/questionBankMangement.vue'),
    },
    //问卷调查
    {
      path: '/questionnaireList',
      name: 'questionnaireList',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/questionnaireList.vue'),
    },
    //问卷调查添加
    {
      path: '/questionnaireAdd',
      name: 'questionnaireAdd',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/questionnaireAdd.vue'),
    },
    //调研对象
    {
      path: '/researchObjectList',
      name: 'researchObjectList',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/researchObjectList.vue'),
    },
    // 算法分配
    {
      path: '/algorithmAllocation',
      name: 'algorithmAllocation',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/algorithmAllocation.vue'),
    },
    //导入管理  销售数据导入
    {
      path: '/importSalesData',
      name: 'importSalesData',
      // meta: { requiresAuth: true },
      component: () => import('../views/importManagement/importSalesData.vue'),
    },
    //导入管理  运费报价
    {
      path: '/importFreightQuotation',
      name: 'importFreightQuotation',
      // meta: { requiresAuth: true },
      component: () => import('../views/importManagement/importFreightQuotation.vue'),
    },
    //导入管理  仓储报价
    {
      path: '/importWarehouseQuotation',
      name: 'importWarehouseQuotation',
      // meta: { requiresAuth: true },
      component: () => import('../views/importManagement/importWarehouseQuotation.vue'),
    },
    //系统参数管理  数据字典
    {
      path: '/parameterDataDictionary',
      name: 'parameterDataDictionary',
      // meta: { requiresAuth: true },
      component: () => import('../views/parameterManagemant/parameterDataDictionary.vue'),
    },
    //系统参数管理  业务参数
    {
      path: '/businessParameters',
      name: 'businessParameters',
      // meta: { requiresAuth: true },
      component: () => import('../views/parameterManagemant/businessParameters.vue'),
    },
    //系统参数管理  AB测试配置
    {
      path: '/ABTestConfiguration',
      name: 'ABTestConfiguration',
      // meta: { requiresAuth: true },
      component: () => import('../views/parameterManagemant/ABTestConfiguration.vue'),
    },
    //账单管理  账单导入
    {
      path: '/expenseImport',
      name: 'expenseImport',
      // meta: { requiresAuth: true },
      component: () => import('../views/expenseManagement/expenseImport.vue'),
    },
    //账单管理  账单列表
    {
      path: '/expenseList',
      name: 'expenseList',
      // meta: { requiresAuth: true },
      component: () => import('../views/expenseManagement/expenseList.vue'),
    },
    // 药店建档变更日志
    {
      path: '/logsFillingList',
      name: 'logsFillingList',
      // meta: { keepAlive: true },
      component: () => import('../views/logsMangement/logsFillingList.vue'),
    },
    //商业公司建档变更日志
    {
      path: '/businessLogs',
      name: 'businessLogs',
      // meta: { keepAlive: true },
      component: () => import('../views/logsMangement/businessLogs.vue'),
    },
    //商业公司建档变更日志详情
    {
      path: '/businessLogsDetail',
      name: 'businessLogsDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/logsMangement/businessLogsDetail.vue'),
    },
    // 医院建档变更日志
    {
      path: '/hospitalLogs',
      name: 'hospitalLogs',
      // meta: { keepAlive: true },
      component: () => import('../views/logsMangement/hospitalLogs.vue'),
    },
    // 医院建档变更日志详情
    {
      path: '/hospitalDetail',
      name: 'hospitalDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/logsMangement/hospitalDetail.vue'),
    },
    // 万年青建档变更日志详情
    {
      path: '/fillingLogDetail',
      name: 'fillingLogDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/logsMangement/fillingLogDetail.vue'),
    },
    /*************** 合同相关开始 *********************/
    // 合同盖章申请管理列表
    {
      path: '/contractSealList',
      name: 'contractSealList',
      meta: { keepAlive: true },
      component: () => import('../views/contractMangement/contractSealList.vue'),
    },
    // 合同盖章申请
    {
      path: '/contractSealAdd',
      name: 'contractSealAdd',
      // meta: { requiresAuth: true },
      component: () => import('../views/contractMangement/contractSealAdd.vue'),
    },
    // 合同盖章申请详情
    {
      path: '/contractSealDetail',
      name: 'contractSealDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/contractMangement/contractSealDetail.vue'),
    },
    // 合同信息申请管理列表
    {
      path: '/contractInformationList',
      name: 'contractInformationList',
      meta: { keepAlive: true },
      component: () => import('../views/contractMangement/contractInformationList.vue'),
    },
    // 合同信息一览列表
    {
      path: '/contractIndex',
      name: 'contractIndex',
      meta: { keepAlive: true },
      component: () => import('../views/contractMangement/contractIndex.vue'),
    },
    // 合同信息申请
    {
      path: '/contractInformationAdd',
      name: 'contractInformationAdd',
      // meta: { requiresAuth: true },
      component: () => import('../views/contractMangement/contractInformationAdd.vue'),
    },
    // 合同信息申请详情
    {
      path: '/contractInformationDetail',
      name: 'contractInformationDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/contractMangement/contractInformationDetail.vue'),
    },
    // 合同终止与作废流程列表
    {
      path: '/contractTerminationList',
      name: 'contractTerminationList',
      meta: { keepAlive: true },
      component: () => import('../views/contractMangement/contractTerminationList.vue'),
    },
    // 合同终止与作废流程申请
    {
      path: '/contractTerminationAdd',
      name: 'contractTerminationAdd',
      // meta: { requiresAuth: true },
      component: () => import('../views/contractMangement/contractTerminationAdd.vue'),
    },
    // 合同终止与作废流程详情
    {
      path: '/contractTerminationDetail',
      name: 'contractTerminationDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/contractMangement/contractTerminationDetail.vue'),
    },
    /*************** 合同相关结束 *********************/
    /*************** 服务推广计划相关开始 *********************/
    // 合市场推广计划申请管理列表
    {
      path: '/marketingPlanList',
      name: 'marketingPlanList',
      // meta: { requiresAuth: true },
      component: () => import('../views/marketManagement/marketingPlanList.vue'),
    },
    // 合市场推广计划申请
    {
      path: '/marketingPlanAdd',
      name: 'marketingPlanAdd',
      // meta: { requiresAuth: true },
      component: () => import('../views/marketManagement/marketingPlanAdd.vue'),
    },
    // 合市场推广计划申请详情
    {
      path: '/marketingPlanDetail',
      name: 'marketingPlanDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/marketManagement/marketingPlanDetail.vue'),
    },
    /*************** 服务推广计划相关结束 *********************/

    // 报表配置平台菜单
    // 销售区域报货累计达成情况
    {
      path: '/orderTerritoryArrivalYTD',
      name: 'orderTerritoryArrivalYTD',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 报货产品排名
    {
      path: '/orderGoodsTop',
      name: 'orderGoodsTop',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 新老终端分析(流向)
    {
      path: '/salesNewOldAnalyse',
      name: 'salesNewOldAnalyse',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 终端报货排名(Rx)
    {
      path: '/orderTerminalTOP',
      name: 'orderTerminalTOP',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 拜访报货转化分析(Rx)
    {
      path: '/orderRxConvertion',
      name: 'orderRxConvertion',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 销售区域流向累计达成情况
    {
      path: '/salesTerritoryArrivalYTD',
      name: 'salesTerritoryArrivalYTD',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 会议分析
    {
      path: '/meetingAnalyse',
      name: 'meetingAnalyse',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 8个图表报表测试
    {
      path: '/eightChartTest',
      name: 'eightChartTest',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 报货数据总结(OTC运营报告)
    {
      path: '/orderOperationOTC',
      name: 'orderOperationOTC',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 报货月度趋势分析
    {
      path: '/orderMonthAnalyse',
      name: 'orderMonthAnalyse',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 终端销售排名
    {
      path: '/terminalSalesTOP',
      name: 'terminalSalesTOP',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 报货产品分析
    {
      path: '/orderGoodsMonthAnalyse',
      name: 'orderGoodsMonthAnalyse',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 终端报货排名(OTC)
    {
      path: '/orderOTCTerminalTOP',
      name: 'orderOTCTerminalTOP',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 库存质量分析
    {
      path: '/warehouseStockQuality',
      name: 'warehouseStockQuality',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 库存分析
    {
      path: '/warehouseStock',
      name: 'warehouseStock',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 拜访类型占比(OTC运营报告)
    {
      path: '/visitCategoryRatio',
      name: 'visitCategoryRatio',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 报货达成月趋势分析
    {
      path: '/orderArrival',
      name: 'orderArrival',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 终端RFM分析(OTC报货)
    {
      path: '/orderTerminalRFM',
      name: 'orderTerminalRFM',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 人均效能分析(报货OTC)
    {
      path: '/orderAverageStaff',
      name: 'orderAverageStaff',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 库龄分析
    {
      path: '/warehouseStockAge',
      name: 'warehouseStockAge',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 人员构成
    {
      path: '/staffComposite',
      name: 'staffComposite',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 拜访流向转化分析(OTC)
    {
      path: '/visitSalesConvertionOTC',
      name: 'visitSalesConvertionOTC',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 拜访流向转化分析(Rx)
    {
      path: '/visitSalesConvertionRx',
      name: 'visitSalesConvertionRx',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 新老终端分析(OTC报货)
    {
      path: '/newOldTerminalOTCAnalyse',
      name: 'newOldTerminalOTCAnalyse',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 销售达成月趋势分析
    {
      path: '/salesArrival',
      name: 'salesArrival',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 销售月度趋势分析
    {
      path: '/salesMonthAnalyse',
      name: 'salesMonthAnalyse',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 拜访报货转化分析(OTC)
    {
      path: '/vistConvertionOTC',
      name: 'vistConvertionOTC',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 打卡分析
    {
      path: '/clockIN',
      name: 'clockIN',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 人员入离职趋势分析
    {
      path: '/staffInOut',
      name: 'staffInOut',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 终端RFM分析(Rx报货)
    {
      path: '/rxOrderTerminalRFM',
      name: 'rxOrderTerminalRFM',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 报货拜访行为转化(OTC运营报告)
    {
      path: '/orderVisitConvertionOTCReport',
      name: 'orderVisitConvertionOTCReport',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 理货分析
    {
      path: '/supportPrice',
      name: 'supportPrice',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 人均效能(报货Rx)
    {
      path: '/prescriptionOrderAverageStaff',
      name: 'prescriptionOrderAverageStaff',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 终端RFM分析(流向)
    {
      path: '/terminalRFM',
      name: 'terminalRFM',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 销售产品排名
    {
      path: '/salesProductTop',
      name: 'salesProductTop',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 销售产品排分析
    {
      path: '/salesProductAnalyse',
      name: 'salesProductAnalyse',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },

    // 报表配置平台菜单
    // 销售区域报货累计达成情况
    {
      path: '/orderTerritoryArrivalYTD',
      name: 'orderTerritoryArrivalYTD',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 报货产品排名
    {
      path: '/orderGoodsTop',
      name: 'orderGoodsTop',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 新老终端分析(流向)
    {
      path: '/salesNewOldAnalyse',
      name: 'salesNewOldAnalyse',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 终端报货排名(Rx)
    {
      path: '/orderRxTerminalTOP',
      name: 'orderRxTerminalTOP',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 拜访报货转化分析(Rx)
    {
      path: '/orderRxConvertion',
      name: 'orderRxConvertion',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 销售区域流向累计达成情况
    {
      path: '/salesTerritoryArrivalYTD',
      name: 'salesTerritoryArrivalYTD',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 会议分析
    {
      path: '/meetingAnalyse',
      name: 'meetingAnalyse',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 8个图表报表测试
    {
      path: '/eightChartTest',
      name: 'eightChartTest',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 报货数据总结(OTC运营报告)
    {
      path: '/orderOperationOTC',
      name: 'orderOperationOTC',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 报货月度趋势分析
    {
      path: '/orderMonthAnalyse',
      name: 'orderMonthAnalyse',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 终端销售排名
    {
      path: '/terminalSalesTOP',
      name: 'terminalSalesTOP',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 报货产品分析
    {
      path: '/orderGoodsMonthAnalyse',
      name: 'orderGoodsMonthAnalyse',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 终端报货排名(OTC)
    {
      path: '/orderOTCTerminalTOP',
      name: 'orderOTCTerminalTOP',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 库存质量分析
    {
      path: '/warehouseStockQuality',
      name: 'warehouseStockQuality',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 库存分析
    {
      path: '/warehouseStock',
      name: 'warehouseStock',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 拜访类型占比(OTC运营报告)
    {
      path: '/visitCategoryRatio',
      name: 'visitCategoryRatio',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 报货达成月趋势分析
    {
      path: '/orderArrival',
      name: 'orderArrival',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 终端RFM分析(OTC报货)
    {
      path: '/orderTerminalRFM',
      name: 'orderTerminalRFM',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 人均效能分析(报货OTC)
    {
      path: '/orderAverageStaff',
      name: 'orderAverageStaff',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 库龄分析
    {
      path: '/warehouseStockAge',
      name: 'warehouseStockAge',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 人员构成
    {
      path: '/staffComposite',
      name: 'staffComposite',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 拜访流向转化分析(OTC)
    {
      path: '/visitSalesConvertionOTC',
      name: 'visitSalesConvertionOTC',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 拜访流向转化分析(Rx)
    {
      path: '/visitSalesConvertionRx',
      name: 'visitSalesConvertionRx',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 新老终端分析(OTC报货)
    {
      path: '/newOldTerminalOTCAnalyse',
      name: 'newOldTerminalOTCAnalyse',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 销售达成月趋势分析
    {
      path: '/salesArrival',
      name: 'salesArrival',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 销售月度趋势分析
    {
      path: '/salesMonthAnalyse',
      name: 'salesMonthAnalyse',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 拜访报货转化分析(OTC)
    {
      path: '/vistConvertionOTC',
      name: 'vistConvertionOTC',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 销售产品分析
    {
      path: '/salesProduct',
      name: 'salesProduct',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 打卡分析
    {
      path: '/clockIN',
      name: 'clockIN',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 人员入离职趋势分析
    {
      path: '/staffInOut',
      name: 'staffInOut',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 终端RFM分析(Rx报货)
    {
      path: '/rxOrderTerminalRFM',
      name: 'rxOrderTerminalRFM',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 报货拜访行为转化(OTC运营报告)
    {
      path: '/orderVisitConvertionOTCReport',
      name: 'orderVisitConvertionOTCReport',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 理货分析
    {
      path: '/supportPrice',
      name: 'supportPrice',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 人均效能(报货Rx)
    {
      path: '/prescriptionOrderAverageStaff',
      name: 'prescriptionOrderAverageStaff',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 终端RFM分析(流向)
    {
      path: '/terminalRFM',
      name: 'terminalRFM',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // RX人员分析
    {
      path: '/RxStaffAnalyse',
      name: 'RxStaffAnalyse',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 人员入离职月趋势Rx
    {
      path: '/staffInOutRx',
      name: 'staffInOutRx',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // Rx薪酬费用月趋势
    {
      path: '/RxSalaryExpense',
      name: 'RxSalaryExpense',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // Rx费用薪酬累计占比
    {
      path: '/RxExpenseSalaryRatio',
      name: 'RxExpenseSalaryRatio',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // Rx投入产出比月趋势
    {
      path: '/RxRoiMonthTred',
      name: 'RxRoiMonthTred',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // Rx区域累计投入产出
    {
      path: '/RxYTDRoiTerritory',
      name: 'RxYTDRoiTerritory',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // Rx人员累计投入产出
    {
      path: '/RxYTDRoiStaff',
      name: 'RxYTDRoiStaff',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 采购报表
    {
      path: '/OrderTestDetail',
      name: 'OrderTestDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 采购产品排名
    {
      path: '/OrderProductTopTest',
      name: 'OrderProductTopTest',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },
    // 拜访分析
    {
      path: '/VisitTset',
      name: 'VisitTset',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportPreview.vue'),
    },

    // 数据管理
    {
      path: '/reportLook',
      name: 'reportLook',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportLook.vue'),
    },

    //资料上传 数据管理
    {
      path: '/dataUpload',
      name: 'dataUpload',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/dataUpload.vue'),
    },
    //资料上传 数据管理
    {
      path: '/dataUpload',
      name: 'dataUpload',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/dataUpload.vue'),
    },
    //超级管理运营公司 药企方管理
    {
      path: '/drugCompanies',
      name: 'drugCompanies',
      // meta: { requiresAuth: true },
      component: () => import('../views/operationMangement/drugCompanies.vue'),
    },
    {
      path: '/addDrugCompanies',
      name: 'addDrugCompanies',
      // meta: { requiresAuth: true },
      component: () => import('../views/operationMangement/addDrugCompanies.vue'),
    },
    //超级管理运营公司 药企方账户管理列表
    {
      path: '/drugCompaniesHome',
      name: 'drugCompaniesHome',
      // meta: { requiresAuth: true },
      component: () => import('../views/drugCompaniesAccount/drugCompaniesHome.vue'),
    },
    //超级管理运营公司 组织架构
    {
      path: '/drugOrganizationalStructure',
      name: 'drugOrganizationalStructure',
      // meta: { requiresAuth: true },
      component: () => import('../views/drugCompaniesAccount/organizationalStructure.vue'),
    },
    //超级管理运营公司 岗位
    {
      path: '/drugPostManagement',
      name: 'drugPostManagement',
      // meta: { requiresAuth: true },
      component: () => import('../views/drugCompaniesAccount/postManagement.vue'),
    },
    //超级管理运营公司 角色
    {
      path: '/drugRoleManagement',
      name: 'drugRoleManagement',
      // meta: { requiresAuth: true },
      component: () => import('../views/drugCompaniesAccount/roleManagement.vue'),
    },
    //超级管理运营公司 销售区域
    {
      path: '/drugSalesArea',
      name: 'drugSalesArea',
      // meta: { requiresAuth: true },
      component: () => import('../views/drugCompaniesAccount/salesArea.vue'),
    },
    //超级管理运营公司 销售区域
    {
      path: '/drugsalesAreaMaintenanceIndex',
      name: 'drugsalesAreaMaintenanceIndex',
      // meta: { requiresAuth: true },
      component: () => import('../views/drugCompaniesAccount/salesAreaMaintenanceIndex.vue'),
    },
    //超级管理运营公司 人员
    {
      path: '/drugManagementPersonnel',
      name: 'drugManagementPersonnel',
      // meta: { requiresAuth: true },
      component: () => import('../views/drugCompaniesAccount/managementPersonnel.vue'),
    },
    {
      path: '/drugImportPersonnel',
      name: 'drugImportPersonnel',
      // meta: { requiresAuth: true },
      component: () => import('../views/drugCompaniesAccount/drugImportPersonnel.vue'),
    },
    //超级管理运营公司 业务单元
    {
      path: '/drugBusinessUnit',
      name: 'drugBusinessUnit',
      // meta: { requiresAuth: true },
      component: () => import('../views/drugCompaniesAccount/businessUnit.vue'),
    },

    // 任务分级规则配置
    {
      path: '/taskCategoryRuleConfig',
      name: 'taskCategoryRuleConfig',
      // meta: { requiresAuth: true },
      component: () => import('../views/taskMangement/taskCategoryRuleConfig.vue'),
    },
    // 任务超级模板管理 任务模版列表
    {
      path: '/drugtaskTemplateConf',
      name: 'drugtaskTemplateConf',
      // meta: { requiresAuth: true },
      component: () => import('../views/taskMangement/superTaskTemplateConf.vue'),
    },
    // 药企人员备案管理 药企人员备案管理
    {
      path: '/personnelFilingHome',
      name: 'personnelFilingHome',
      // meta: { requiresAuth: true },
      component: () => import('../views/personnelFiling/filingManagementPersonnelNew.vue'),
    },
    // v26.3.3 数据标注 基础资料管理-认证资料管理
    {
      path: '/certInfoManage',
      name: 'certInfoManage',
      component: () => import('../views/certManagement/certInfoManage.vue'),
    },
    // v26.3.3 数据标注 基础资料管理-认证审核管理
    {
      path: '/certAuditManage',
      name: 'certAuditManage',
      component: () => import('../views/certManagement/certAuditManage.vue'),
    },
    // v26.3.3 数据标注 基础资料管理-认证审核详情
    {
      path: '/certAuditManageDetail',
      name: 'certAuditManageDetail',
      component: () => import('../views/certManagement/certAuditManageDetail.vue'),
    },
    // v26.3.3 数据标注 基础资料管理-平台保密协议签署
    {
      path: '/platformProtocolSign',
      name: 'platformProtocolSign',
      component: () => import('../views/certManagement/platformProtocolSign.vue'),
    },
    // v26.3.3 数据标注 系统管理-预标注模型配置
    {
      path: '/prelabelModelConf',
      name: 'prelabelModelConf',
      component: () => import('../views/certManagement/prelabelModelConf.vue'),
    },
    // v26.3.3 数据标注 系统管理-标注标签模板
    {
      path: '/labelTemplateConf',
      name: 'labelTemplateConf',
      component: () => import('../views/certManagement/labelTemplateConf.vue'),
    },
    // v26.3.3 数据标注 业务管理-标注数据管理
    {
      path: '/labelDatasetManage',
      name: 'labelDatasetManage',
      component: () => import('../views/certManagement/labelDatasetManage.vue'),
    },
    // v26.3.3 数据标注 系统管理-标注标签新增/编辑
    {
      path: '/labelTemplateEdit',
      name: 'labelTemplateEdit',
      component: () => import('../views/certManagement/labelTemplateEdit.vue'),
    },
    // v26.3.3 数据标注 任务执行-标注页嵌入（医生端，micro-app）
    {
      path: '/labelExecution',
      name: 'labelExecution',
      component: () => import('../views/taskExecution/labelExecution.vue'),
    },
    // v26.3.3 数据标注 业务管理-待整改标注任务列表（菜单用户自配）
    {
      path: '/labelRectificationList',
      name: 'labelRectificationList',
      component: () => import('../views/certManagement/labelRectificationList.vue'),
    },
    // v26.3.3 数据标注 业务管理-数据标注审核列表（菜单用户自配）
    // keepAlive：从 labelToolDetail 返回时保住环节 tab 选中态（activeStage 随组件缓存），
    // 数据刷新由页内 activated 钩子重查（页面缓存但接口重新请求，2026-09-24 拍板）
    {
      path: '/labelAuditList',
      name: 'labelAuditList',
      component: () => import('../views/certManagement/labelAuditList.vue'),
      meta: { keepAlive: true },
    },
    // v26.3.3 数据标注 审核详情/待整改详情（嵌标注系统，mode=audit|rectify）
    {
      path: '/labelToolDetail',
      name: 'labelToolDetail',
      component: () => import('../views/certManagement/labelToolDetail.vue'),
    },
    // 药企人员备案管理 人员备案管信息(已废弃)
    {
      path: '/filingManagementPersonnel', // (已废弃)
      name: 'filingManagementPersonnel', // (已废弃)
      // meta: { requiresAuth: true },
      component: () => import('../views/personnelFiling/filingManagementPersonnel.vue'), // (已废弃)
    },
    // 药企人员备案管理 人员备案管组织
    {
      path: '/filingOrganizationalStructure',
      name: 'filingOrganizationalStructure',
      // meta: { requiresAuth: true },
      component: () => import('../views/personnelFiling/filingOrganizationalStructure.vue'),
    },
    // 药企人员备案管理 人员备案管岗位
    {
      path: '/filingPostManagement',
      name: 'filingPostManagement',
      // meta: { requiresAuth: true },
      component: () => import('../views/personnelFiling/filingPostManagement.vue'),
    },
    // 药企人员备案管理 人员备案管角色
    {
      path: '/filingRoleManagement',
      name: 'filingRoleManagement',
      // meta: { requiresAuth: true },
      component: () => import('../views/personnelFiling/filingRoleManagement.vue'),
    },
    // 药企人员备案管理 销售区域
    {
      path: '/filingSalesArea',
      name: 'filingSalesArea',
      // meta: { requiresAuth: true },
      component: () => import('../views/personnelFiling/filingSalesArea.vue'),
    },
    // 简历信息审核详情
    {
      path: '/cvInforReview',
      name: 'cvInforReview',
      // meta: { requiresAuth: true },
      component: () => import('../views/personnelFiling/cvInforReview.vue'),
    },
    // 简历信息审核列表
    {
      path: '/cvInforReviewList',
      name: 'cvInforReviewList',
      // meta: { requiresAuth: true },
      component: () => import('../views/personnelFiling/cvInforReviewList.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 恋链首页广告配置列表
    {
      path: '/advConfigList',
      name: 'advConfigList',
      // meta: { requiresAuth: true },
      component: () => import('../views/advertisingConfiguration/advConfigList.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 新增恋链首页广告配置
    {
      path: '/addAdvConfig',
      name: 'addAdv',
      // meta: { requiresAuth: true },
      component: () => import('../views/advertisingConfiguration/addAdvConfig.vue'),
    },
    // 药企账号管理 销售区域
    {
      path: '/salesArea',
      name: 'salesArea',
      // meta: { requiresAuth: true },
      component: () => import('../views/organizationalStructure/salesArea.vue'),
    },
    // 药企账号管理 销售区域
    {
      path: '/salesAreaMaintenanceIndex',
      name: 'salesAreaMaintenanceIndex',
      // meta: { requiresAuth: true },
      component: () => import('../views/organizationalStructure/salesAreaMaintenanceIndex.vue'),
    },
    // 任务执行 任务执行列表
    {
      path: '/taskExecutionList',
      name: 'taskExecutionList',
      meta: { keepAlive: true },
      component: () => import('../views/taskExecution/taskExecutionList.vue'),
    },
    // 任务执行 问卷导入
    {
      path: '/surveyExport',
      name: 'surveyExport',
      // meta: { requiresAuth: true },
      component: () => import('../views/taskExecution/surveyExport.vue'),
    },
    {
      path: '/importNewSurveyExport',
      name: 'importNewSurveyExport',
      // meta: { requiresAuth: true },
      component: () => import('../views/importNewManagement/importNewSurveyExport.vue'),
    },
     // 导入新-流向数据采集
    {
      path: '/importNewFlowTask',
      name: 'importNewFlowTask',
      // meta: { requiresAuth: true },
      component: () => import('../views/importNewManagement/importNewFlowTask.vue'),
    },
    //医院报货
    {
      path: '/rxOrder',
      name: 'rxOrder',
      // meta: { requiresAuth: true },
      component: () => import('../views/reportManagement/goodsReport.vue'),
      // meta: { keepAlive: true },
    },
    //商业报货报货
    {
      path: '/franchiseeOrder',
      name: 'franchiseeOrder',
      // meta: { requiresAuth: true },
      component: () => import('../views/reportManagement/customerReport.vue'),
      // meta: { keepAlive: true },
    },
    //药店报货
    {
      path: '/order',
      name: 'order',
      // meta: { requiresAuth: true },
      component: () => import('../views/reportManagement/terminalReport.vue'),
      // meta: { keepAlive: true },
    },
    // 任务执行 问卷预览
    {
      path: '/surveyPreview',
      name: 'surveyPreview',
      // meta: { requiresAuth: true },
      component: () => import('../views/taskExecution/surveyPreview.vue'),
    },
    // 任务执行 查看完成列表
    {
      path: '/surveyFinishList',
      name: 'surveyFinishList',
      // meta: { requiresAuth: true },
      component: () => import('../views/taskExecution/surveyFinishList.vue'),
    },
    // 任务执行-流向任务管理
    {
      path: '/flowTaskFinishList',
      name: 'flowTaskFinishList',
      // meta: { requiresAuth: true },
      component: () => import('../views/taskExecution/flowTaskFinishList.vue'),
    },
    // 问卷 问卷结果
    {
      path: '/surveyFinishOwn',
      name: 'surveyFinishOwn',
      // meta: { requiresAuth: true },
      component: () => import('../views/taskExecution/surveyFinishOwn.vue'),
    },
    // 报表供应链数据导航
    {
      path: '/reportLookTe',
      name: 'reportLookTe',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/reportLookTe.vue'),
    },
    // 科室管理
    {
      path: '/departmentManagement',
      name: 'departmentManagement',
      // meta: { requiresAuth: true },
      component: () => import('../views/departmentManagement/departmentManagement.vue'),
    },
   // 科室管理导入
   {
    path: '/importDepartment',
    name: 'importDepartment',
    // meta: { requiresAuth: true },
    component: () => import('../views/departmentManagement/importDepartment.vue'),
  },
    //通讯录-商业客户列表
    {
      path: '/businessCustomerList',
      name: 'businessCustomerList',
      meta: { keepAlive: true },
      // meta: { requiresAuth: true },
      component: () => import('../views/concatFilling/businessCustomerList.vue'),
    },
    // 商业公司关系人审核
    {
      path: '/businessCustomerAudit',
      name: 'businessCustomerAudit',
      // meta: { keepAlive: true },
      component: () => import('../views/concatFilling/businessCustomerAudit.vue'),
    },
    //通讯录-商业客户新增
    {
      path: '/businessCustomerAdd',
      name: 'businessCustomerAdd',
      // meta: { requiresAuth: true },
      component: () => import('../views/concatFilling/businessCustomerAdd.vue'),
    },
    //通讯录-居间人列表
    {
      path: '/intermediaryList',
      name: 'intermediaryList',
      meta: { keepAlive: true },
      // meta: { requiresAuth: true },
      component: () => import('../views/concatFilling/intermediaryList.vue'),
    },
    //通讯录-居间人审核
    {
      path: '/intermediaryAudit',
      name: 'intermediaryAudit',
      // meta: { keepAlive: true },
      // meta: { requiresAuth: true },
      component: () => import('../views/concatFilling/intermediaryAudit.vue'),
    },
    //通讯录-居间人新增
    {
      path: '/intermediaryAdd',
      name: 'intermediaryAdd',
      // meta: { requiresAuth: true },
      component: () => import('../views/concatFilling/intermediaryAdd.vue'),
    },
    // 药店
    {
      path: '/pharmacy',
      name: 'pharmacy',
      meta: { keepAlive: true },
      component: () => import('../views/dataManagement/pharmacy.vue'),
    },
    // 药店审核
    {
      path: '/pharmacyAudit',
      name: 'pharmacyAudit',
      // meta: { keepAlive: true },
      component: () => import('../views/dataManagement/pharmacyAudit.vue'),
    },

    // 药店详情
    {
      path: '/pharmacyDetail/detail',
      name: 'pharmacyDetail/detail',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/pharmacyDetail.vue'),
    },
    // 医院
    {
      path: '/medQuery',
      name: 'medQuery',
      meta: { keepAlive: true },
      component: () => import('../views/dataManagement/medQuery.vue'),
    },
    // 医院审核
    {
      path: '/medQueryAudit',
      name: 'medQueryAudit',
      // meta: { keepAlive: true },
      component: () => import('../views/dataManagement/medQueryAudit.vue'),
    },
    // 药店详情
    {
      path: '/medQueryDetail/detail',
      name: 'medQueryDetail/detail',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/medQueryDetail.vue'),
    },

    // 商品大类维护
    {
      path: '/commodityCategory',
      name: 'commodityCategory',
      meta: { keepAlive: true },
      component: () => import('../views/dataManagement/commodityCategory.vue'),
    },
    // 商品资料维护
    {
      path: '/productInformation',
      name: 'productInformation',
      meta: { keepAlive: true },
      component: () => import('../views/dataManagement/productInformation.vue'),
    },
    // 新增/编辑/详情 产品
    {
      path: '/addProduct',
      name: 'addProduct',
      component: () => import('../views/dataManagement/addProduct.vue'),
    },
    //资料管理  维护区域指导价
    {
      path: '/productGuidePrice',
      name: 'productGuidePrice',
      meta: { keepAlive: true },
      component: () => import('../views/dataManagement/productGuidePrice.vue'),
    },
    //资料管理  维护医院指导价
    {
      path: '/productHospitalPrice',
      name: 'productHospitalPrice',
      meta: { keepAlive: true },
      component: () => import('../views/dataManagement/productHospitalPrice.vue'),
    },
    {
      path: '/commercialCompanyinquiry',
      name: 'commercialCompanyinquiry',
      meta: { s: true,keepAlive: true },
      component: () => import('../views/dataManagement/commercialCompanyinquiry.vue'),
    },
    // 商业公司审核
    {
      path: '/commercialCompanyAudit',
      name: 'commercialCompanyAudit',
      // meta: { keepAlive: true },
      component: () => import('../views/dataManagement/commercialCompanyAudit.vue'),
    },

    // 商业公司详情
    {
      path: '/commercialCompanyinquiryDetail/detail',
      name: '/commercialCompanyinquiryDetail/detail',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/commercialCompanyinquiryDetail.vue'),
    },
    // 潜在药店
    {
      path: '/pharmacyPotentialList',
      name: 'pharmacyPotentialList',
      meta: { keepAlive: true },
      component: () => import('../views/dataManagement/pharmacyPotentialList.vue'),
    },

    // 潜在药店详情
    {
      path: '/pharmacyPotentialAdd',
      name: 'pharmacyPotentialAdd',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/pharmacyPotentialAdd.vue'),
    },
    // 导入
    {
      path: '/importPharmacyPotential',
      name: 'importPharmacyPotential',
      // meta: { requiresAuth: true },
      component: () => import('../views/importCustomerManagement/importPharmacyPotential.vue'),
    },

    /******** start of 客户管理 ********/
    // 代征平台首次维护
    {
      path: '/maintenanceFirstList',
      name: 'maintenanceFirstList',
      component: () => import('../views/customerManagement/maintenanceFirstList.vue'),
    },
    {
      path: '/maintenanceFirstEidt',
      name: 'maintenanceFirstEidt',
      component: () => import('../views/customerManagement/maintenanceFirstEidt.vue'),
    },
    // 代征平台资料管理
    {
      path: '/maintenanceMgtTable',
      name: 'maintenanceMgtTable',
      component: () => import('../views/customerManagement/maintenanceMgtTable.vue'),
      meta: { keepAlive: true }
    },
    {
      path: '/maintenanceMgtEdit',
      name: 'maintenanceMgtEdit',
      component: () => import('../views/customerManagement/maintenanceMgtEdit.vue'),
    },
    // 代征平台定期维护
    {
      path: '/maintenanceRegularList',
      name: 'maintenanceRegularList',
      component: () => import('../views/customerManagement/maintenanceRegularList.vue'),
    },
    {
      path: '/maintenanceRegularEidt',
      name: 'maintenanceRegularEidt',
      component: () => import('../views/customerManagement/maintenanceRegularEidt.vue'),
    },
    // 服务商首次维护
    {
      path: '/servicerFirstList',
      name: 'servicerFirstList',
      component: () => import('../views/customerManagement/servicerFirstList.vue'),
    },
    {
      path: '/servicerFirstEidt',
      name: 'servicerFirstEidt',
      component: () => import('../views/customerManagement/servicerFirstEidt.vue'),
    },
    // 服务商资料管理列表
    {
      path: '/serviceManagementTable',
      name: 'serviceManagementTable',
      component: () => import('../views/customerManagement/serviceManagementTable.vue'),
      meta: { keepAlive: true }
    },
    // 服务商资料管理新增/编辑
    {
      path: '/serviceManagementEdit',
      name: 'serviceManagementEdit',
      component: () => import('../views/customerManagement/serviceManagementEdit.vue'),
    },
    // 服务商定期维护
    {
      path: '/servicerRegularList',
      name: 'servicerRegularList',
      component: () => import('../views/customerManagement/servicerRegularList.vue'),
    },
    {
      path: '/servicerRegularEidt',
      name: 'servicerRegularEidt',
      component: () => import('../views/customerManagement/servicerRegularEidt.vue'),
    },
    /******** end of 客户管理 ********/

    /******************************************* start of 上游结算 ************************************/
    //质量考核审批列表
    {
      path: '/qualityApprovalList',
      name: 'qualityApprovalList',
      component: () => import('../views/taskAudit/qualityApprovalList.vue'),
      meta: { keepAlive: true },
    },
    //质量考核审批新增
    {
      path: '/qualityApprovalAdd',
      name: 'qualityApprovalAdd',
      component: () => import('../views/taskAudit/qualityApprovalAdd.vue'),
    },
    //质量考核审批详情
    {
      path: '/qualityApprovalDetail',
      name: 'qualityApprovalDetail',
      component: () => import('../views/taskAudit/qualityApprovalDetail.vue'),
    },
    //上游管理列表
    {
      path: '/upstreamSettlementManagementList',
      name: 'upstreamSettlementManagementList',
      component: () => import('../views/upstreamSettlementManagement/upstreamSettlementManagementList.vue'),
      meta: { keepAlive: true },
    },

    //上游预运营报告新增
    {
      path: '/upstreamOperationReportAdd',
      name: 'upstreamOperationReportAdd',
      component: () => import('../views/upstreamSettlementManagement/upstreamOperationReportAdd.vue'),
    },
    //上游运营报告详情
    {
      path: '/upstreamOperationReportDetail',
      name: 'upstreamOperationReportDetail',
      component: () => import('../views/upstreamSettlementManagement/upstreamOperationReportDetail.vue'),
    },
    //上游开票申请新增
    {
      path: '/upstreampaymentAdd',
      name: 'upstreampaymentAdd',
      meta: { keepAlive: true },
      component: () => import('../views/upstreamSettlementManagement/upstreampaymentAdd.vue'),
    },
    //上游开票申请详情
    {
      path: '/upstreampaymentDetail',
      name: 'upstreampaymentDetail',
      component: () => import('../views/upstreamSettlementManagement/upstreampaymentDetail.vue'),
    },
    //上游开票新增
    {
      path: '/upstreamInvoicingAdd',
      name: 'upstreamInvoicingAdd',
      component: () => import('../views/upstreamSettlementManagement/upstreamInvoicingAdd.vue'),
    },
    //上游开票详情
    {
      path: '/upstreamInvoicingDetail',
      name: 'upstreamInvoicingDetail',
      component: () => import('../views/upstreamSettlementManagement/upstreamInvoicingDetail.vue'),
    },
    //上游预开票新增
    {
      path: '/upstreamAdvanceInvoiceAdd',
      name: 'upstreamAdvanceInvoiceAdd',
      component: () => import('../views/upstreamSettlementManagement/upstreamAdvanceInvoiceAdd.vue'),
    },
    //上游预开票详情
    {
      path: '/upstreamAdvanceInvoiceDetail',
      name: 'upstreamAdvanceInvoiceDetail',
      component: () => import('../views/upstreamSettlementManagement/upstreamAdvanceInvoiceDetail.vue'),
    },
    //上游对冲 首页
    {
      path: '/upstreamHedgingIndex',
      name: 'upstreamHedgingIndex',
      component: () => import('../views/upstreamHedgingManagement/upstreamHedgingIndex.vue'),
    },
    //上游对冲 新增
    {
      path: '/upstreamHedgingAdd',
      name: 'upstreamHedgingAdd',
      component: () => import('../views/upstreamHedgingManagement/upstreamHedgingAdd.vue'),
    },
    //上游对冲 详情
    {
      path: '/upstreamHedgingDetail',
      name: 'upstreamHedgingDetail',
      component: () => import('../views/upstreamHedgingManagement/upstreamHedgingDetail.vue'),
    },
    /******************************************* end of 上游结算 ************************************/
    //
    //SPD运营费率设置
    //operatingRate
    {
      path: '/operatingRate',
      name: 'operatingRate',
      meta: {
        keepAlive: true,
        isBack: false, //用于判断上一个页面是哪个
      },
      component: () => import('../views/operateSPD/operatingRate.vue'),
    },
    //设置商品费率
    {
      path: '/operatingRate/goodsRate',
      name: 'operatingRate/goodsRate',
      // meta: { requiresAuth: true },
      component: () => import('../views/operateSPD/goodsRate.vue'),
    },
    //运营费到账填报
    //fillReceipt
    {
      path: '/fillReceipt',
      name: 'fillReceipt',
      // meta: { requiresAuth: true },
      meta: { keepAlive: true },

        component: () => import('../views/operateSPD/fillReceipt.vue'),
      },
      //运营费用重新计算
      {
        path: '/fillReceipt/expenseConfirmationDetail',
        name: 'expenseConfirmationDetail',
        // meta: { requiresAuth: true },
        component: () => import('../views/operateSPD/expenseConfirmationDetail.vue'),
      },
      //运营费用统计报表
      //statisticalReport
      {
        path: '/statisticalReport',
        name: 'statisticalReport',
        // meta: { requiresAuth: true },
        component: () => import('../views/operateSPD/statisticalReport.vue'),
      },
      //费用统计详情
      {
        path: '/statisticalReport/statisticalReportDetail',
        name: 'statisticalReport/detail',
        // meta: { requiresAuth: true },
        component: () => import('../views/operateSPD/statisticalReportDetail.vue'),
      },
      //运营费用确认
      {
        path: '/expenseConfirmation',
        name: 'expenseConfirmation',
        // meta: { requiresAuth: true },
        component: () => import('../views/operateSPD/expenseConfirmation.vue'),
      },
        //汇总统计
        {
          path: '/statisticalReport/statisticalReportDetail/summaryStatistics',
          name: 'statisticalReport/summaryStatistics',
          // meta: { requiresAuth: true },
          component: () => import('../views/operateSPD/summaryStatistics.vue'),
        },
      /*******************************************  新流程管理界面 开始   ********************************************/
      // 新流程管理列表
      {
        path: '/workFlowList',
        name: 'workFlowList',
        // meta: { requiresAuth: true },
        component: () => import('../views/workFlowManagement/workFlowList.vue'),
      },
      // 药店新客户详情-流程页面
      {
        path: '/pharmacyPageDetail-06',
        name: 'pharmacyPageDetail',
        // meta: { requiresAuth: true },
        component: () => import('../views/workFlowManagement/pharmacyPageDetail-06.vue'),
      },
      // 药店新客户修改详情-流程页面
      {
        path: '/pharmacyPageEditDetail-07',
        name: 'pharmacyPageEditDetail',
        // meta: { requiresAuth: true },
        component: () => import('../views/workFlowManagement/pharmacyPageEditDetail-07.vue'),
      },
      // 药店客户等级变更详情-流程页面
      {
        path: '/pharmacyLevelDetail-08',
        name: 'pharmacyPageEditDetail',
        // meta: { requiresAuth: true },
        component: () => import('../views/workFlowManagement/pharmacyLevelDetail-08.vue'),
      },
      /*******************************************  新流程管理界面 结束   ********************************************/
      // 导入优化界面
      {
        path: '/importNewManagementList',
        name: 'importNewManagementList',
        // meta: { requiresAuth: true },
        component: () => import('../views/importNewManagement/importNewManagementList.vue'),
      },
      // 潜在药店导入优化界面
      {
        path: '/importNewPharmacyPotential',
        name: 'importNewPharmacyPotential',
        // meta: { requiresAuth: true },
        component: () => import('../views/importNewManagement/importNewPharmacyPotential.vue'),
      },
            // 花名册导入优化界面
      {
        path: '/importNewPerson',
        name: 'importNewPerson',
        // meta: { requiresAuth: true },
        component: () => import('../views/importNewManagement/importNewPerson.vue'),
      },
      // 产品资料导入
      {
        path: '/importProductInfoList',
        name: 'importProductInfoList',
        // meta: { keepAlive: true },
        component: () => import('../views/importNewManagement/importProductInfoList.vue'),
      },
      // 上下游财务信息导入
      {
        path: '/importFinancialInfor',
        name: 'importFinancialInfor',
        // meta: { requiresAuth: true },
        component: () => import('../views/importNewManagement/importFinancialInfor.vue'),
      },
      //企业开户
      {
        path: '/tenantAccountOpening',
        name: 'tenantAccountOpening',
        // meta: { requiresAuth: true },
        component: () => import('../views/organizationalStructure/tenantAccountOpening.vue'),
      },
      //医药学堂
      {
        path: '/medicineSchoolList',
        name: 'medicineSchool',
        meta: { keepAlive: true },
        component: () => import('../views/medicineSchoolManagement/medicineSchoolList.vue'),
      },
      // 医药词典内容发布
      {
        path: '/medicineSchoolAdd',
        name: 'medicineSchoolAdd',
        // meta: { requiresAuth: true },
        component: () => import('../views/medicineSchoolManagement/medicineSchoolAdd.vue'),
      },
      // 医药政策内容发布
      {
        path: '/medicinePolicyAdd',
        name: 'medicinePolicyAdd',
        // meta: { requiresAuth: true },
        component: () => import('../views/medicineSchoolManagement/medicinePolicyAdd.vue'),
      },
      // 医药政策导入
      {
        path: '/importPolicyList',
        name: 'importPolicyList',
        // meta: { requiresAuth: true },
        component: () => import('../views/importNewManagement/importPolicyList.vue'),
      },
      // 市场拓展目标管理
      {
        path: '/marketingTargetList',
        name: 'marketingTargetList',
        meta: { keepAlive: true },
        component: () => import('../views/marketManagement/marketingTargetList.vue'),
      },
      // 市场拓展目标管理新增
      {
        path: '/marketingTargetAdd',
        name: 'marketingTargetAdd',
        // meta: { requiresAuth: true },
        component: () => import('../views/marketManagement/marketingTargetAdd.vue'),
      },
      // 市场拓展目标管理详情
      {
        path: '/marketingTargetDetail',
        name: 'marketingTargetDetail',
        // meta: { requiresAuth: true },
        component: () => import('../views/marketManagement/marketingTargetDetail.vue'),
      },
      // 市场拓展目标管理导入
      {
        path: '/importmarketingTarget',
        name: 'importmarketingTarget',
        // meta: { requiresAuth: true },
        component: () => import('../views/marketManagement/importmarketingTarget.vue'),
      },
       // 平台公告管理列表
      {
        path: '/platformAnnouncementList',
        name: 'platformAnnouncementList',
        meta: { keepAlive: true },
        component: () => import('../views/platformAnnouncementManagement/platformAnnouncementList.vue'),
      },
      // 发布公告
      {
        path: '/addAnnounce',
        name: 'addAnnounce',
        // meta: { requiresAuth: true },
        component: () => import('../views/platformAnnouncementManagement/addAnnounce.vue'),
      },
       // 平台字典管理列表
       {
        path: '/platformDictList',
        name: 'platformDictList',
        meta: { keepAlive: true },
        component: () => import('../views/platformAnnouncementManagement/platformDictList.vue'),
      },
       // 平台字典导入
       {
        path: '/importPlatDictList',
        name: 'importPlatDictList',
        // meta: { requiresAuth: true },
        component: () => import('../views/platformAnnouncementManagement/importPlatDictList.vue'),
      },

    {
      path: '/importCvInfor',
      name: 'importCvInfor',
      // meta: { requiresAuth: true },
      component: () => import('../views/importNewManagement/importCvInfor.vue'),
    },
    // 导入更新状态
    {
      path: '/importNewStateList',
      name: 'importNewStateList',
      // meta: { requiresAuth: true },
      component: () => import('../views/importNewManagement/importNewStateList.vue'),
    },
    {
      path: '/dataCleaningImport',
      name: 'dataCleaningImport',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/dataCleaningImport.vue'),
    },
    // 角色模板列表
    {
      path: '/roleTempletList',
      name: 'roleTempletList',
      // meta: { requiresAuth: true },
      component: () => import('../views/roleManagementNew/roleTempletList.vue'),
    },
    // 角色模板编辑
    {
      path: '/addTempletConfig',
      name: 'addTempletConfig',
      // meta: { requiresAuth: true },
      component: () => import('../views/roleManagementNew/addTempletConfig.vue'),
    },
    // 角色模板编辑
    {
      path: '/addRoleConfig',
      name: 'addRoleConfig',
      // meta: { requiresAuth: true },
      component: () => import('../views/roleManagementNew/addRoleConfig.vue'),
    },
    // 问卷 问卷结果标注
    {
      path: '/surveyFinishMark',
      name: 'surveyFinishMark',
      // meta: { requiresAuth: true },
      component: () => import('../views/taskExecution/surveyFinishMark.vue'),
    },
     // 简历信息导入
     {
      path: '/importResumeList',
      name: 'importResumeList',
      // meta: { requiresAuth: true },
      component: () => import('../views/importNewManagement/importResumeList.vue'),
    },


    // 数据管理
    {
      path: '/reportQuery-1',
      name: 'reportQuery-1',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    // 数据管理
    {
      path: '/reportQuery-2',
      name: 'reportQuery-2',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    // 数据管理
    {
      path: '/reportQuery-3',
      name: 'reportQuery-3',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    // 数据管理
    {
      path: '/reportQuery-4',
      name: 'reportQuery-4',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    // 数据管理
    {
      path: '/reportQuery-5',
      name: 'reportQuery-5',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    // 数据管理
    {
      path: '/reportQuery-6',
      name: 'reportQuery-6',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    // 数据管理
    {
      path: '/reportQuery-7',
      name: 'reportQuery-7',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    // 数据管理
    {
      path: '/reportQuery-8',
      name: 'reportQuery-8',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    // 数据管理
    {
      path: '/reportQuery-9',
      name: 'reportQuery-9',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    // 数据管理
    {
      path: '/reportQuery-10',
      name: 'reportQuery-10',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },


    //报货管理
    {
      path: '/reportQuery-01',
      name: 'reportQuery-01',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-02',
      name: 'reportQuery-02',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-03',
      name: 'reportQuery-03',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-04',
      name: 'reportQuery-04',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-05',
      name: 'reportQuery-05',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-06',
      name: 'reportQuery-06',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-07',
      name: 'reportQuery-07',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-08',
      name: 'reportQuery-08',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-09',
      name: 'reportQuery-09',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-10',
      name: 'reportQuery-10',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-11',
      name: 'reportQuery-11',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-12',
      name: 'reportQuery-12',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-13',
      name: 'reportQuery-13',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-14',
      name: 'reportQuery-14',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-15',
      name: 'reportQuery-15',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-16',
      name: 'reportQuery-16',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    }, {
      path: '/reportQuery-17',
      name: 'reportQuery-17',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-18',
      name: 'reportQuery-18',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-19',
      name: 'reportQuery-19',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-20',
      name: 'reportQuery-20',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-21',
      name: 'reportQuery-21',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-22',
      name: 'reportQuery-22',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-23',
      name: 'reportQuery-23',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-24',
      name: 'reportQuery-24',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-25',
      name: 'reportQuery-25',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-26',
      name: 'reportQuery-26',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-27',
      name: 'reportQuery-27',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-28',
      name: 'reportQuery-28',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-29',
      name: 'reportQuery-29',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-30',
      name: 'reportQuery-30',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-31',
      name: 'reportQuery-31',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-32',
      name: 'reportQuery-32',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-33',
      name: 'reportQuery-33',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-34',
      name: 'reportQuery-34',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-35',
      name: 'reportQuery-35',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-36',
      name: 'reportQuery-36',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-37',
      name: 'reportQuery-37',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-38',
      name: 'reportQuery-38',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-39',
      name: 'reportQuery-39',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-40',
      name: 'reportQuery-40',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-41',
      name: 'reportQuery-41',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-42',
      name: 'reportQuery-42',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-43',
      name: 'reportQuery-43',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-44',
      name: 'reportQuery-44',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-45',
      name: 'reportQuery-45',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-46',
      name: 'reportQuery-46',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-47',
      name: 'reportQuery-47',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-48',
      name: 'reportQuery-48',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-49',
      name: 'reportQuery-49',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-50',
      name: 'reportQuery-50',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-51',
      name: 'reportQuery-51',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-52',
      name: 'reportQuery-52',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-53',
      name: 'reportQuery-53',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-54',
      name: 'reportQuery-54',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-55',
      name: 'reportQuery-55',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-56',
      name: 'reportQuery-56',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-57',
      name: 'reportQuery-57',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-58',
      name: 'reportQuery-58',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-59',
      name: 'reportQuery-59',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-60',
      name: 'reportQuery-60',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-61',
      name: 'reportQuery-61',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-62',
      name: 'reportQuery-62',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-63',
      name: 'reportQuery-63',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-64',
      name: 'reportQuery-64',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-65',
      name: 'reportQuery-65',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-66',
      name: 'reportQuery-66',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-67',
      name: 'reportQuery-67',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-68',
      name: 'reportQuery-68',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-69',
      name: 'reportQuery-69',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-70',
      name: 'reportQuery-70',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-71',
      name: 'reportQuery-71',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-72',
      name: 'reportQuery-72',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-73',
      name: 'reportQuery-73',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-74',
      name: 'reportQuery-74',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-75',
      name: 'reportQuery-75',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-76',
      name: 'reportQuery-76',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-77',
      name: 'reportQuery-77',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-78',
      name: 'reportQuery-78',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-79',
      name: 'reportQuery-79',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-80',
      name: 'reportQuery-80',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-81',
      name: 'reportQuery-81',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-82',
      name: 'reportQuery-82',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-83',
      name: 'reportQuery-83',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-84',
      name: 'reportQuery-84',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-85',
      name: 'reportQuery-85',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-86',
      name: 'reportQuery-86',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-87',
      name: 'reportQuery-87',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-88',
      name: 'reportQuery-88',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-89',
      name: 'reportQuery-89',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-90',
      name: 'reportQuery-90',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-91',
      name: 'reportQuery-91',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-92',
      name: 'reportQuery-92',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-93',
      name: 'reportQuery-93',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-94',
      name: 'reportQuery-94',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-95',
      name: 'reportQuery-95',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-96',
      name: 'reportQuery-96',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-97',
      name: 'reportQuery-97',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-98',
      name: 'reportQuery-98',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-99',
      name: 'reportQuery-99',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-100',
      name: 'reportQuery-100',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-101',
      name: 'reportQuery-101',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-102',
      name: 'reportQuery-102',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-103',
      name: 'reportQuery-103',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-104',
      name: 'reportQuery-104',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-105',
      name: 'reportQuery-105',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-106',
      name: 'reportQuery-106',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-107',
      name: 'reportQuery-107',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-108',
      name: 'reportQuery-108',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-109',
      name: 'reportQuery-109',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-110',
      name: 'reportQuery-110',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-111',
      name: 'reportQuery-111',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-121',
      name: 'reportQuery-121',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-122',
      name: 'reportQuery-122',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-131',
      name: 'reportQuery-131',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-132',
      name: 'reportQuery-132',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-133',
      name: 'reportQuery-133',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-134',
      name: 'reportQuery-134',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-135',
      name: 'reportQuery-135',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-136',
      name: 'reportQuery-136',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-137',
      name: 'reportQuery-137',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-138',
      name: 'reportQuery-138',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-141',
      name: 'reportQuery-141',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-142',
      name: 'reportQuery-142',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-151',
      name: 'reportQuery-151',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-152',
      name: 'reportQuery-152',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-153',
      name: 'reportQuery-153',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-161',
      name: 'reportQuery-161',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-162',
      name: 'reportQuery-162',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-163',
      name: 'reportQuery-163',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-171',
      name: 'reportQuery-171',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-172',
      name: 'reportQuery-172',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-173',
      name: 'reportQuery-173',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-181',
      name: 'reportQuery-181',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-182',
      name: 'reportQuery-182',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-183',
      name: 'reportQuery-183',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-191',
      name: 'reportQuery-191',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-192',
      name: 'reportQuery-192',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-193',
      name: 'reportQuery-193',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-201',
      name: 'reportQuery-201',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    {
      path: '/reportQuery-211',
      name: 'reportQuery-211',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-query.vue'),
    },
    // 数据管理
    {
      path: '/reportQueryList-0',
      name: 'reportQueryList-0',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-copy.vue'),
    },
    // 数据管理
    {
      path: '/reportQueryList-1',
      name: 'reportQueryList-1',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-copy.vue'),
    },
    // 数据管理
    {
      path: '/reportQueryList-2',
      name: 'reportQueryList-2',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-copy.vue'),
    },
    // 数据管理
    {
      path: '/reportQueryList-3',
      name: 'reportQueryList-3',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-copy.vue'),
    },
    // 数据管理
    {
      path: '/reportQueryList-4',
      name: 'reportQueryList-4',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-copy.vue'),
    },
    // 数据管理
    {
      path: '/reportQueryList-5',
      name: 'reportQueryList-5',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-copy.vue'),
    },
    // 数据管理
    {
      path: '/reportQueryList-6',
      name: 'reportQueryList-6',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-copy.vue'),
    },
    // 数据管理
    {
      path: '/reportQueryList-7',
      name: 'reportQueryList-7',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-copy.vue'),
    },
    // 数据管理
    {
      path: '/reportQueryList-8',
      name: 'reportQueryList-8',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-copy.vue'),
    },
    // 数据管理
    {
      path: '/reportQueryList-9',
      name: 'reportQueryList-9',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-copy.vue'),
    },
    // 数据管理
    {
      path: '/reportQueryList-10',
      name: 'reportQueryList-10',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-copy.vue'),
    },
    // 数据管理
    {
      path: '/reportQueryList-11',
      name: 'reportQueryList-11',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-copy.vue'),
    },
    // 数据管理
    {
      path: '/reportQueryList-12',
      name: 'reportQueryList-12',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-copy.vue'),
    },
    // 数据管理
    {
      path: '/reportQueryList-13',
      name: 'reportQueryList-13',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-copy.vue'),
    },
    // 数据管理
    {
      path: '/reportQueryList-14',
      name: 'reportQueryList-14',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-copy.vue'),
    },
    // 数据管理
    {
      path: '/reportQueryList-15',
      name: 'reportQueryList-15',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-copy.vue'),
    },
    // 数据管理
    {
      path: '/reportQueryList-20',
      name: 'reportQueryList-20',
      // meta: { requiresAuth: true },
      component: () => import('../views/dataManagement/report-copy.vue'),
    },
    // 任务管理 任务大类配置
    {
      path: '/taskClassConf',
      name: 'taskClassConf',
      // meta: { requiresAuth: true },
      component: () => import('../views/taskMangement/taskClassConf.vue'),
    },
    // 任务管理 任务要求配置
    {
      path: '/taskReqConf',
      name: 'taskReqConf',
      // meta: { requiresAuth: true },
      component: () => import('../views/taskMangement/taskReqConf.vue'),
    },
    // 任务管理 任务单位配置
    {
      path: '/taskUnitConf',
      name: 'taskUnitConf',
      // meta: { requiresAuth: true },
      component: () => import('../views/taskMangement/taskUnitConf.vue'),
    },
    // 任务管理 任务内容配置
    {
      path: '/taskContentConf',
      name: 'taskContentConf',
      // meta: { requiresAuth: true },
      component: () => import('../views/taskMangement/taskContentConf.vue'),
    },
    // 任务管理 任务模版列表
    {
      path: '/taskTemplateConf',
      name: 'taskTemplateConf',
      meta: { keepAlive: true },
      component: () => import('../views/taskMangement/taskTemplateConf.vue'),
    },
    // 任务管理 任务模版配置
    {
      path: '/taskTemplateConfEdit',
      name: 'taskTemplateConfEdit',
      // meta: { requiresAuth: true },
      component: () => import('../views/taskMangement/taskTemplateConfEdit.vue'),
    },
    // 任务管理 任务包列表
    {
      path: '/taskDeliverList-01',
      name: 'taskDeliverList-01',
      meta: {
        keepAlive: true,
      },
      component: () => import('../views/taskMangement/taskDeliverList-01.vue'),
    },
    // 任务管理 任务包列表
    {
      path: '/taskDeliverList-02',
      name: 'taskDeliverList-02',
      meta: {
        keepAlive: true,
      },
      component: () => import('../views/taskMangement/taskDeliverList-02.vue'),
    },
    // 任务管理 任务包列表
    {
      path: '/taskDeliverList-03',
      name: 'taskDeliverList-03',
      meta: {
        keepAlive: true,
      },
      component: () => import('../views/taskMangement/taskDeliverList-03.vue'),
    },
    {
      path: '/taskConversionList',
      name: 'taskConversionList',
      meta: {
        keepAlive: true,
      },
      component: () => import('../views/taskMangement/taskConversionList.vue'),
    },
    {
      path: '/serviceProviderChangeLog',
      name: 'serviceProviderChangeLog',
      meta: {
        keepAlive: true,
      },
      component: () => import('../views/taskMangement/serviceProviderChangeLog.vue'),
    },
    {
      path: '/retentionTaskConversion',
      name: 'retentionTaskConversion',
      meta: {
        keepAlive: true,
      },
      component: () => import('../views/taskMangement/RetentionTaskConversion/index.vue'),
    },
    {
      path: '/retentionTaskConversionProgress',
      name: 'retentionTaskConversionProgress',
      meta: {
        keepAlive: true,
      },
      component: () => import('../views/taskMangement/RetentionTaskConversion/retentionTaskConversionProgress.vue'),
    },
    // 任务管理 任务包派发审批
    {
      path: '/taskDeliverList-04',
      name: 'taskDeliverList-04',
      meta: {
        keepAlive: true,
      },
      component: () => import('../views/taskMangement/taskDeliverList-04.vue'),
    },
    // 任务管理 任务包派发变更审批
    {
      path: '/taskDeliverList-05',
      name: 'taskDeliverList-05',
      meta: {
        keepAlive: true,
      },
      component: () => import('../views/taskMangement/taskDeliverList-05.vue'),
    },
    // 任务管理 任务包派发流程详情
    {
      path: '/taskDeliverModifyFlow01',
      name: 'taskDeliverModifyFlow01',
      component: () => import('../views/taskMangement/taskDeliverModifyFlow01.vue'),
    },
    // 任务管理 任务包变更流程详情
    {
      path: '/taskDeliverModifyFlow02',
      name: 'taskDeliverModifyFlow02',
      component: () => import('../views/taskMangement/taskDeliverModifyFlow02.vue'),
    },
    //任务流程看版
    {
      path: '/taskBoard',
      name: 'taskBoard',
      component: () => import('../views/taskMangement/taskBoard.vue'),
    },
    // 任务管理 新增任务包
    {
      path: '/taskDeliverAdd',
      name: 'taskDeliverAdd',
      // meta: { requiresAuth: true },
      component: () => import('../views/taskMangement/taskDeliverAdd.vue'),
    },
    // 任务管理 任务包受理(详情)
    {
      path: '/taskDeliverModify',
      name: 'taskDeliverModify',
      // meta: { requiresAuth: true },
      component: () => import('../views/taskMangement/taskDeliverModify.vue'),
    },
    //任务管理 工作任务派发（详情）
    {
      path: '/taskDeliverDetail',
      name: 'taskDeliverDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/taskMangement/taskDeliverDetail.vue'),
    },
    // 任务管理 任务包修改
    {
      path: '/taskDeliverModify-02',
      name: 'taskDeliverModify-02',
      // meta: { requiresAuth: true },
      component: () => import('../views/taskMangement/taskDeliverModify-02.vue'),
    },
    // 任务进度
    {
      path: '/taskProgress',
      name: 'taskProgress',
      component: () => import('../views/taskMangement/taskProgress.vue'),
    },
    // 版本管理
    {
      path: '/editionList',
      name: 'editionList',
      // meta: { requiresAuth: true },
      component: () => import('../views/edition/editionList.vue'),
    },
    // 历史版本
    {
      path: '/historyEditionList',
      name: 'historyEditionList',
      // meta: { requiresAuth: true },
      component: () => import('../views/edition/historyEditionList.vue'),
    },
    {
      path: '/delegationManage',
      name: 'delegationManage',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeEmployment/delegationManage.vue'),
    },
    // 合同签订 合同管理
    {
      path: '/contractList',
      name: 'contractList',
      // meta: { requiresAuth: true },
      component: () => import('../views/contractMangement/contractList.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 合同签订 合同详情
    {
      path: '/contractDetail',
      name: 'contractDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/contractMangement/contractDetail.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 运营报告管理 运营报告
    {
      path: '/operationReport',
      name: 'operationReport',
      // meta: { requiresAuth: true },
      component: () => import('../views/operationMangement/operationReportNew.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 费用结算 结算单
    {
      path: '/freeList',
      name: 'freeList',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeMangement/freeList.vue'),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/iconManagement',
      name: 'iconManagement',
      component: () => import('../views/parameterManagemant/iconManagement.vue'),
    },
    // 费用结算 完税凭证管理
    {
      path: '/taxPaymentVoucher',
      name: 'taxPaymentVoucher',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeMangement/taxPaymentVoucher.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 费用结算 支付凭证管理
    {
      path: '/paymentVoucher',
      name: 'paymentVoucher',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeMangement/paymentVoucher.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 费用结算 工资条管理
    {
      path: '/payRollList',
      name: 'payRollList',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeMangement/payRollList.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 费用结算 工资条管理
    {
      path: '/payRollDetail',
      name: 'payRollDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeMangement/payRollDetail.vue'),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/importPayRollData',
      name: 'importPayRollData',
      // meta: { requiresAuth: true },
      component: () => import('../views/freeMangement/importPayRollData.vue'),
      meta: {
        keepAlive: true,
      },
    }, {
      path: '/productUnitList',
      name: 'productUnitList',
      // meta: { requiresAuth: true },
      component: () => import('../views/systemParameter/productUnitList.vue'),
      meta: {
        keepAlive: true,
      },
    },

    //评分设置
    {
      path: '/scoreConfigList',
      name: 'scoreConfigList',
      component: () => import('../views/scoreMangement/scoreConfigList.vue'),

    },
    // 平台服务人员准入规则
    {
      path: '/accessRuleConfig',
      name: 'accessRuleConfig',
      component: () => import('../views/scoreMangement/accessRuleConfig.vue'),
    },
    // 任务质量审核
    {
      path: '/taskAudit',
      name: 'taskAudit',
      // meta: { keepAlive: true },
      component: () => import('../views/taskAudit/taskAudit.vue'),
    },

    //考核配置列表
    {
      path: '/checkConfigList',
      name: 'checkConfigList',
      component: () => import('../views/checkMangement/checkConfigList.vue'),
    },
    // 项目考核机制列表
    {
      path: '/orgCheckConfigList',
      name: 'orgCheckConfigList',
      component: () => import('../views/checkMangement/orgCheckConfigList.vue'),
    },
    //考核配置列表批量复制
    {
      path: '/checkConfigListToCopy',
      name: 'checkConfigListToCopy',
      component: () => import('../views/checkMangement/checkConfigListToCopy.vue'),
    },
    //考核任务列表
    {
      path: '/checkTaskList',
      name: 'checkTaskList',
      component: () => import('../views/checkMangement/checkTaskList.vue'),
    },
    //考核任务列表
    {
      path: '/checkSalaryList',
      name: 'checkSalaryList',
      component: () => import('../views/checkMangement/checkSalaryList.vue'),
    },
    //考核任务列表
    {
      path: '/checkRetained',
      name: 'checkRetained',
      component: () => import('../views/checkMangement/checkRetained.vue'),
    },
    //考核任务列表
    {
      path: '/insureImport',
      name: 'insureImport',
      component: () => import('../views/checkMangement/insureImport.vue'),
    },
    //考核任务列表
    {
      path: '/waitCheckDetail',
      name: 'waitCheckDetail',
      component: () => import('../views/checkMangement/waitCheckDetail.vue'),
    },
    //任务及收入查询-列表
    {
      path: '/checkSearchList',
      name: 'checkSearchList',
      component: () => import('../views/checkMangement/checkSearchList.vue'),
    },
    //任务及收入查询-详情
    {
      path: '/checkSearchDetail',
      name: 'checkSearchDetail',
      component: () => import('../views/checkMangement/checkSearchDetail.vue'),
    },
    //运营方管理  离职继承列表
    {
      path: '/resignationInheritance',
      name: 'resignationInheritance',
      // meta: { requiresAuth: true },
      component: () => import('../views/organizationalStructure/resignationInheritance.vue'),
    },
    //运营方管理  离职继承详情
    {
      path: '/resignationInheritanceDetail',
      name: 'resignationInheritanceDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/organizationalStructure/resignationInheritanceDetail.vue'),
    },

    {
      path: '/salesOrder',
      name: 'salesOrder',
      // meta: { requiresAuth: true },
      component: () => import('../views/orderMangement/salesOrder.vue'),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/purchaseOrder',
      name: 'purchaseOrder',
      // meta: { requiresAuth: true },
      component: () => import('../views/orderMangement/purchaseOrder.vue'),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/portrait/portraitHome',
      name: 'portraitHome',
      component: () => import('../views/portraitMangement/portraitHome.vue'),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/portrait/BMapHome',
      name: 'BMapHome',
      component: () => import('../views/portraitMangement/portraitHome-BMap.vue'),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/portraitBMap',
      name: 'portraitBMap',
      component: () => import('../views/portraitMangement/portraitBMap.vue'),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/portraitSalesman',
      name: 'portraitSalesman',
      component: () => import('../views/portraitMangement/portraitSalesman.vue'),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/portraitDetail',
      name: 'portraitDetail',
      component: () => import('../views/portraitMangement/portraitDetail.vue'),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/portrait/salesmanList',
      name: 'salesmanList',
      component: () => import('../views/portraitMangement/salesmanList.vue'),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/portrait/salesmanDetail',
      name: 'salesmanDetail',
      component: () => import('../views/portraitMangement/salesmanDetail.vue'),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/portrait/relativeNetwork',
      name: 'relativeNetwork',
      component: () => import('../views/portraitMangement/relativeNetwork.vue'),
      meta: {
        keepAlive: true,
      },
    },
    //立项申请列表
    {
      path: '/projectIndex',
      name: 'projectIndex',
      meta: { keepAlive: true },
      component: () => import('../views/creatProjectFlowManagement/projectIndex.vue'),
    },
    //立项申请表单
    {
      path: '/projectEdit',
      name: 'projectEdit',
      component: () => import('../views/creatProjectFlowManagement/projectEdit.vue'),
    },
    //立项申请详情
    {
      path: '/projectDetail',
      name: 'projectDetail',
      component: () => import('../views/creatProjectFlowManagement/projectDetail.vue'),
    },
    //服务商列表
    {
      path: '/serverTaskIndex',
      name: 'serverTaskIndex',
      component: () => import('../views/serverTaskMangement/serverTaskIndex.vue'),
    },
    //服务商详情
    {
      path: '/serverTaskDetail',
      name: 'serverTaskDetail',
      component: () => import('../views/serverTaskMangement/serverTaskDetail.vue'),
    },
    //上游发票信息管理列表
    {
      path: '/upstreamInvoiceIndex',
      name: 'upstreamInvoiceIndex',
      meta: { keepAlive: true },
      component: () => import('../views/updownstreamInvoiceManagement/upstreamInvoiceIndex.vue'),
    },
    //上游发票信息管理编辑
    {
      path: '/upstreamInvoiceEdit',
      name: 'upstreamInvoiceEdit',
      component: () => import('../views/updownstreamInvoiceManagement/upstreamInvoiceEdit.vue'),
    },
    //上游预支付
    {
      path: '/addUpstreamPaymentPlan',
      name: 'addUpstreamPaymentPlan',
      component: () => import('../views/updownstreamInvoiceManagement/addUpstreamPaymentPlan.vue'),
    },
    // 上游收款信息管理
    {
      path: '/upstreamCollectionIndex',
      name: 'upstreamCollectionIndex',
      component: () => import('../views/updownstreamInvoiceManagement/upstreamCollectionIndex.vue'),
      meta: {
        keepAlive: true,
      },
    },
    //下游发票收款信息管理列表
    {
      path: '/downstreamInvoiceIndex',
      name: 'downstreamInvoiceIndex',
      meta: { keepAlive: true },
      component: () => import('../views/updownstreamInvoiceManagement/downstreamInvoiceIndex.vue'),
    },
    //下游收款信息管理
    {
      path: '/downstreamCollectionIndex',
      name: 'downstreamCollectionIndex',
      component: () => import('../views/updownstreamInvoiceManagement/downstreamCollectionIndex.vue'),
    },
    //下游退款信息管理
    {
      path: '/downstreamRefundIndex',
      name: 'downstreamRefundIndex',
      component: () => import('../views/updownstreamInvoiceManagement/downstreamRefundIndex.vue'),
    },
    //下游发票收款信息管理编辑
    {
      path: '/downstreamInvoiceEdit',
      name: 'downstreamInvoiceEdit',
      component: () => import('../views/updownstreamInvoiceManagement/downstreamInvoiceEdit.vue'),
    },
    /********* start of 下游结算审批 *********/
    // 下游结算审批列表页
    {
      path: '/downstreamSettlement',
      name: 'downstreamSettlement',
      component: () => import('../views/settlementApproval/downstreamSettlement/index.vue'),
      meta: { keepAlive: true },
    },
    // 结算单流程
    {
      path: '/settlementDoc',
      name: 'settlementDoc',
      component: () => import('../views/settlementApproval/downstreamSettlement/settlementDoc.vue'),
    },
    // 结算单流程详情
    {
      path: '/settlementDocDetail',
      name: 'settlementDocDetail',
      component: () => import('../views/settlementApproval/downstreamSettlement/settlementDocDetail.vue'),
    },
    // 下游付款流程
    {
      path: '/downstreamPayment',
      name: 'downstreamPayment',
      component: () => import('../views/settlementApproval/downstreamSettlement/downstreamPayment.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 下游付款流程详情_旧
    {
      path: '/downstreamPaymentDetail_old',
      name: 'downstreamPaymentDetail_old',
      component: () => import('../views/settlementApproval/downstreamSettlement/downstreamPaymentDetail_old.vue'),
    },
    // 下游付款流程详情
    {
      path: '/downstreamPaymentDetail',
      name: 'downstreamPaymentDetail',
      component: () => import('../views/settlementApproval/downstreamSettlement/downstreamPaymentDetail.vue'),
    },
    // 下游金额对冲流程
    {
      path: '/hedgeAmount',
      name: 'hedgeAmount',
      component: () => import('../views/settlementApproval/downstreamSettlement/hedgeAmount.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 下游金额对冲流程详情
    {
      path: '/hedgeAmountDetail',
      name: 'hedgeAmountDetail',
      component: () => import('../views/settlementApproval/downstreamSettlement/hedgeAmountDetail.vue'),
      meta: {
        keepAlive: true,
      },
    },
    // 对账单申请
    {
      path: '/settlementBill',
      name: 'settlementBill',
      component: () => import('../views/settlementApproval/downstreamSettlement/settlementBill.vue'),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/settlementBillDetail',
      name: 'settlementBillDetail',
      component: () => import('../views/settlementApproval/downstreamSettlement/settlementBillDetail.vue'),
      meta: {
        keepAlive: true,
      },
    },
    /********* start enf 下游结算审批 *********/
    //停线列表
    {
      path: '/lineStopList',
      name: 'lineStopList',
      component: () => import('../views/lineStopManagement/lineStopList.vue'),
      meta: {
        keepAlive: true,
      },
    },
    //停线编辑
    {
      path: '/lineStopEdit',
      name: 'lineStopEdit',
      component: () => import('../views/lineStopManagement/lineStopEdit.vue'),
    },
    //停线详情
    {
      path: '/lineStopDetail',
      name: 'lineStopDetail',
      component: () => import('../views/lineStopManagement/lineStopDetail.vue'),
    },
    //请假列表
    {
      path: '/vacationList',
      name: 'vacationList',
      component: () => import('../views/vacationManagement/vacationList.vue'),
      meta: {
        keepAlive: true,
      }
    },
    //请假编辑
    {
      path: '/vacationEdit',
      name: 'vacationEdit',
      component: () => import('../views/vacationManagement/vacationEdit.vue'),
    },
    {
      path: '/vacationDetail',
      name: 'vacationDetail',
      component: () => import('../views/vacationManagement/vacationDetail.vue'),
    },
    //数据可靠性等级 评级指标管理
    {
      path: '/ratingManagement',
      name: 'ratingManagement',
      component: () => import('../views/dataRating/ratingManagement.vue'),
    },
    //数据可靠性等级 评级模型配置
    {
      path: '/ratingModelConfiguration',
      name: 'ratingModelConfiguration',
      component: () => import('../views/dataRating/ratingModelConfiguration.vue'),
    },
    //数据可靠性等级 评级打分管理
    {
      path: '/ratingScoreManagement',
      name: 'ratingScoreManagement',
      component: () => import('../views/dataRating/ratingScoreManagement.vue'),
    },

    //配置数据映射
    {
      path: '/configIndex',
      name: 'configIndex',
      component: () => import('../views/developerManagement/configIndex.vue'),
    },
    {
      path: '/configEdit',
      name: 'configEdit',
      component: () => import('../views/developerManagement/configEdit.vue'),
    },
    // 调查问卷任务质量审核
    {
      path: '/questionnaireAudit',
      name: 'questionnaireAudit',
      // meta: { keepAlive: true },
      component: () => import('../views/taskAudit/questionnaireAudit.vue'),
    },
    //批量清除微信id
    {
      path: '/batchCleanWxId',
      name: 'batchCleanWxId',
      component: () => import('../views/cleanWxId/batchCleanWxId.vue'),
    },
    // 产品批号管理
    {
      path: '/productBatchManagement',
      name: 'productBatchManagement',
      meta: { keepAlive: true },
      component: () => import('../views/dataManagement/productBatchManagement.vue'),
    },
    // 新增/编辑/详情 产品
    {
      path: '/addProductBatch',
      name: 'addProductBatch',
      component: () => import('../views/dataManagement/addProductBatch.vue'),
    },
    // 产品批号导入
    {
      path: '/importProductBatchList',
      name: 'importProductBatchList',
      component: () => import('../views/importNewManagement/importProductBatchList.vue'),
    },
    // 传世任务审核导入
    {
      path: '/platformTaskImport',
      name: 'platformTaskImport',
      component: () => import('../views/platformTaskMangement/platformTaskImport.vue'),
    },
    // 档案资料审核
    {
      path: '/customerDataAudit',
      name: 'customerDataAudit.vue',
      meta: { keepAlive: true },
      component: () => import('../views/dataManagement/customerDataAudit.vue'),
    },

    // 敬请期待
    {
      path: '/comingSoon-01',
      name: 'comingSoon-01',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-02',
      name: 'comingSoon-02',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-03',
      name: 'comingSoon-03',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-04',
      name: 'comingSoon-04',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-05',
      name: 'comingSoon-05',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-06',
      name: 'comingSoon-06',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-07',
      name: 'comingSoon-07',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-08',
      name: 'comingSoon-08',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-09',
      name: 'comingSoon-09',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-10',
      name: 'comingSoon-10',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-11',
      name: 'comingSoon-11',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-12',
      name: 'comingSoon-12',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-13',
      name: 'comingSoon-13',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-14',
      name: 'comingSoon-14',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-15',
      name: 'comingSoon-15',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-16',
      name: 'comingSoon-16',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-17',
      name: 'comingSoon-17',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-18',
      name: 'comingSoon-18',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-19',
      name: 'comingSoon-19',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-20',
      name: 'comingSoon-20',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-21',
      name: 'comingSoon-21',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-22',
      name: 'comingSoon-22',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-23',
      name: 'comingSoon-23',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-24',
      name: 'comingSoon-24',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-25',
      name: 'comingSoon-25',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-26',
      name: 'comingSoon-26',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-27',
      name: 'comingSoon-27',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-28',
      name: 'comingSoon-28',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-29',
      name: 'comingSoon-29',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-30',
      name: 'comingSoon-30',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-31',
      name: 'comingSoon-31',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-32',
      name: 'comingSoon-32',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-33',
      name: 'comingSoon-33',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-34',
      name: 'comingSoon-34',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-35',
      name: 'comingSoon-35',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-36',
      name: 'comingSoon-36',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-37',
      name: 'comingSoon-37',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-38',
      name: 'comingSoon-38',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-39',
      name: 'comingSoon-39',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-40',
      name: 'comingSoon-40',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-41',
      name: 'comingSoon-41',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-42',
      name: 'comingSoon-42',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-43',
      name: 'comingSoon-43',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-44',
      name: 'comingSoon-44',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-45',
      name: 'comingSoon-45',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-46',
      name: 'comingSoon-46',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-47',
      name: 'comingSoon-47',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-48',
      name: 'comingSoon-48',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-49',
      name: 'comingSoon-49',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-50',
      name: 'comingSoon-50',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-51',
      name: 'comingSoon-51',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-52',
      name: 'comingSoon-52',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-53',
      name: 'comingSoon-53',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-54',
      name: 'comingSoon-54',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-55',
      name: 'comingSoon-55',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-56',
      name: 'comingSoon-56',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-57',
      name: 'comingSoon-57',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-58',
      name: 'comingSoon-58',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-59',
      name: 'comingSoon-59',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-60',
      name: 'comingSoon-60',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-61',
      name: 'comingSoon-61',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-62',
      name: 'comingSoon-62',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-63',
      name: 'comingSoon-63',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-64',
      name: 'comingSoon-64',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-65',
      name: 'comingSoon-65',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-66',
      name: 'comingSoon-66',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-67',
      name: 'comingSoon-67',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-68',
      name: 'comingSoon-68',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-69',
      name: 'comingSoon-69',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/comingSoon-70',
      name: 'comingSoon-70',
      // meta: { requiresAuth: true },
      component: () => import('../views/comingSoon.vue'),
    },
    {
      path: '/marketTzList',
      name: 'marketTzList',
      meta: {
        keepAlive: true,
      },
      component: () => import('../views/marketTzMangement/marketTzList.vue'),
    },
    {
      path: '/marketTzEdit',
      name: 'marketTzEdit',
      // meta: { requiresAuth: true },
      component: () => import('../views/marketTzMangement/marketTzEdit.vue'),
    },
    {
      path: '/marketTzDetail',
      name: 'marketTzDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/marketTzMangement/marketTzDetail.vue'),
    },
    {
      path: '/platformTaskList',
      name: 'platformTaskList',
      // meta: { requiresAuth: true },
      component: () => import('../views/platformTaskMangement/platformTaskList.vue'),
    },
    {
      path: '/platformTaskReview', // 传世任务审核
      name: 'platformTaskReview',
      // meta: { requiresAuth: true },
      component: () => import('../views/platformTaskMangement/platformTaskReview.vue'),
    },
    {
      path: '/platformTaskEdit',
      name: 'platformTaskEdit',
      // meta: { requiresAuth: true },
      component: () => import('../views/platformTaskMangement/platformTaskEdit.vue'),
    },
    {
      path: '/platformTaskDetail',
      name: 'platformTaskDetail',
      // meta: { requiresAuth: true },
      component: () => import('../views/platformTaskMangement/platformTaskDetail.vue'),
    },
        // 终端地址清洗
    {
      path: '/terminalAddressClean',
      name: 'terminalAddressClean',
      // meta: { requiresAuth: true },
      component: () => import('../views/concatFilling/terminalAddressClean.vue'),
    },
    {
      path: '/importTaskList',
      name: 'importTaskList',
      component: () => import('../views/taskAudit/importTaskList.vue')
    },
// 金额转大写测试页（临时测试工具，无菜单入口，URL 直达）
    {
      path: '/upDigitTest',
      name: 'upDigitTest',
      component: () => import('../views/tools/upDigitTest.vue')
    },
    // 消息模板配置（自平台管理端 supplyPlatformManagement 移植）
    {
      path: '/msgManagementConfig',
      name: 'msgManagementConfig',
      component: () => import('../views/messageManagement/msg-management-config.vue')
    }
  ],
}]

export default [...routes, ...Login];
// export default routes;
